(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("fJAMg", function(module, exports) {

$parcel$export(module.exports, "getElements", function () { return $b74796364388c903$export$73eac51a39d6b0eb; });
$parcel$export(module.exports, "InlineEntrypoint", function () { return $b74796364388c903$export$fcd24c965d9aa26a; });
$parcel$export(module.exports, "render", function () { return $b74796364388c903$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "goTo", function () { return $b74796364388c903$export$95e8d77caafa3e06; });
$parcel$export(module.exports, "initSmartnav", function () { return $b74796364388c903$export$8d4a4a389ba6cafa; });
$parcel$export(module.exports, "init", function () { return $b74796364388c903$export$2cd8252107eb640b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hfCPd = parcelRequire("hfCPd");

var $kJhYp = parcelRequire("kJhYp");

var $dJ00A = parcelRequire("dJ00A");

var $bBMv4 = parcelRequire("bBMv4");

var $d86AX = parcelRequire("d86AX");

var $9rqV0 = parcelRequire("9rqV0");

var $insiF = parcelRequire("insiF");

var $b5aRK = parcelRequire("b5aRK");

var $dJhID = parcelRequire("dJhID");

var $5bEXW = parcelRequire("5bEXW");

var $jjS2R = parcelRequire("jjS2R");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $cdK26 = parcelRequire("cdK26");

var $6e14p = parcelRequire("6e14p");

var $8E2YL = parcelRequire("8E2YL");

var $5BWWq = parcelRequire("5BWWq");

var $hm3Un = parcelRequire("hm3Un");
function $b74796364388c903$export$73eac51a39d6b0eb(param) {
    return $i7mYY.map($i7mYY.keepMap($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll("#maker-smartnav-inline")), $b5aRK.ofNode), function(node) {
        return node;
    }), $dJ00A.setupAltFunnelElement);
}
function $b74796364388c903$var$InlineEntrypoint$InlineEntrypoint(Props) {
    var configId = Props.configId;
    var embedTypeOpt = Props.embedType;
    var attributes = Props.attributes;
    var element = Props.element;
    var trackers = Props.trackers;
    var onAddToCart = Props.onAddToCart;
    var onOpenLink = Props.onOpenLink;
    var embedType = embedTypeOpt !== undefined ? embedTypeOpt : /* Inline */ 1;
    var attributes$1 = $9rqV0.Attributes.useAttributesObserver(element, attributes);
    var namespace = $9rqV0.getNamespace(attributes$1);
    var accountId = $2whNH.flatMap(attributes$1, function(attr) {
        return attr.account;
    });
    $g85JO.useEffect(function() {
        if (!$cdK26.isProductPage(undefined)) $hm3Un.clearLastCategory(undefined);
    }, []);
    $g85JO.useEffect(function() {
        return $iv6Yc._1($insiF.preload, undefined);
    }, []);
    $g85JO.useEffect(function() {
        var $$event = new Event("maker-smartnav-inline-rendered");
        document.dispatchEvent($$event);
    });
    var tmp = {
        configId: configId,
        embedType: embedType
    };
    if (attributes$1 !== undefined) tmp.attributes = $loT9g.valFromOption(attributes$1);
    var tmp$1 = {
        children: /*#__PURE__*/ $g85JO.createElement($6e14p.make, $6e14p.makeProps(/*#__PURE__*/ $g85JO.createElement($5BWWq.make, {
            value: {
                accountId: accountId,
                trackers: trackers,
                onAddToCart: onAddToCart,
                onOpenLink: onOpenLink
            },
            children: /*#__PURE__*/ $g85JO.createElement($aSJcu.Provider.make, {
                children: /*#__PURE__*/ $g85JO.createElement($hBcYV.make, {
                    configId: configId,
                    defaultInitialRoute: {
                        TAG: /* Home */ 0,
                        _0: {
                            homeType: /* Index */ 0,
                            filters: undefined,
                            sort: undefined
                        }
                    },
                    embedType: embedType,
                    children: /*#__PURE__*/ $g85JO.createElement($8E2YL.make, {
                        configId: configId,
                        children: /*#__PURE__*/ $g85JO.createElement($hfCPd.Provider.make, {
                            children: /*#__PURE__*/ $g85JO.createElement($d86AX.make, tmp)
                        }),
                        enableTrimmingTreeByReferrer: true
                    })
                })
            })
        }), undefined, undefined))
    };
    if (namespace !== undefined) tmp$1.namespace = $loT9g.valFromOption(namespace);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.StrictMode, {
        children: /*#__PURE__*/ $g85JO.createElement($efwy1.Provider.make, tmp$1)
    });
}
$b74796364388c903$var$InlineEntrypoint$InlineEntrypoint.displayName = "InlineEntrypoint.InlineEntrypoint";
var $b74796364388c903$export$fcd24c965d9aa26a = {
    make: $b74796364388c903$var$InlineEntrypoint$InlineEntrypoint
};
function $b74796364388c903$export$b3890eb0ae9dca99(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes) {
    var elementId = element.id;
    var newDictEntry = [
        [
            elementId,
            element
        ]
    ];
    var attributes$1 = $2whNH.map(attributes, function(attr) {
        return attr.attributes;
    });
    try {
        $2whNH.forEach(window.smartNavElementsInline, function(smartNavElements) {
            $2whNH.forEach($d3YYW.get(smartNavElements, elementId), $5bEXW.unmountComponentAtNode);
        });
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        console.error("unable to unmount smartNavElementInline", e);
    }
    window.smartNavElementsInline = $2whNH.mapWithDefault(window.smartNavElementsInline, $d3YYW.fromArray(newDictEntry), function(elements) {
        return $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(elements), newDictEntry));
    });
    element.setAttribute("data-maker-smartnav-inline", "true");
    var tmp = {
        configId: configId,
        element: element,
        key: configId
    };
    if (attributes$1 !== undefined) tmp.attributes = $loT9g.valFromOption(attributes$1);
    if (trackers !== undefined) tmp.trackers = $loT9g.valFromOption(trackers);
    if (onAddToCart !== undefined) tmp.onAddToCart = $loT9g.valFromOption(onAddToCart);
    if (onOpenLink !== undefined) tmp.onOpenLink = $loT9g.valFromOption(onOpenLink);
    $5bEXW.render(/*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
        componentName: "Root",
        children: /*#__PURE__*/ $g85JO.createElement($b74796364388c903$var$InlineEntrypoint$InlineEntrypoint, tmp)
    })), element);
}
function $b74796364388c903$export$95e8d77caafa3e06(quickView, quickNav, replaceState, preserveScroll, namespace) {
    $kJhYp.goTo(namespace, undefined, quickView, quickNav, replaceState, preserveScroll, undefined);
}
function $b74796364388c903$export$8d4a4a389ba6cafa(index, element) {
    return $b74796364388c903$var$_initSmartnav.apply(this, arguments);
}
function $b74796364388c903$var$_initSmartnav() {
    $b74796364388c903$var$_initSmartnav = (0, $5YOUh._)(function(index, element) {
        var attributes, configId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $9rqV0.Attributes.autoAssignNamespaces(undefined);
                    attributes = $9rqV0.Attributes.fromElement(element);
                    return [
                        4,
                        $jjS2R.getConfigId(undefined, undefined, undefined, attributes, /* Inline */ 1)
                    ];
                case 1:
                    configId = _state.sent();
                    if (configId !== undefined) return [
                        2,
                        $b74796364388c903$export$b3890eb0ae9dca99(configId, undefined, undefined, undefined, false, element, {
                            embedType: /* Inline */ 1,
                            attributes: attributes
                        })
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $b74796364388c903$var$_initSmartnav.apply(this, arguments);
}
function $b74796364388c903$export$2cd8252107eb640b(param) {
    var elements = $b74796364388c903$export$73eac51a39d6b0eb(undefined);
    if (elements.length !== 0) return $i7mYY.forEachWithIndex(elements, function(index, element) {
        $b74796364388c903$export$8d4a4a389ba6cafa(index, element);
    });
    else {
        console.error("Could not initialize SmartNav: no element found");
        return;
    }
}
 /* react Not a pure module */ 
});
parcelRegister("dJ00A", function(module, exports) {

$parcel$export(module.exports, "isAltFunnel", function () { return $9fdf7c0153f60f3f$export$9757da9f9bbb9c14; });
$parcel$export(module.exports, "setupAltFunnelElement", function () { return $9fdf7c0153f60f3f$export$562500b99c3c89c; });
$parcel$export(module.exports, "appendBottomBar", function () { return $9fdf7c0153f60f3f$export$c8603593494de511; });
$parcel$export(module.exports, "updateAltFunnelVariant", function () { return $9fdf7c0153f60f3f$export$4289ce05efcce874; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ceAXu = parcelRequire("ceAXu");

var $7GW0c = parcelRequire("7GW0c");

var $cdK26 = parcelRequire("cdK26");
function $9fdf7c0153f60f3f$export$606c153358defcb8(param) {
    try {
        return $loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get("QNConfigId__alt"));
    } catch (exn) {
        return;
    }
}
function $9fdf7c0153f60f3f$export$9757da9f9bbb9c14(param) {
    return $2whNH.isSome($9fdf7c0153f60f3f$export$606c153358defcb8(undefined));
}
function $9fdf7c0153f60f3f$export$562500b99c3c89c(element) {
    var configId = $9fdf7c0153f60f3f$export$606c153358defcb8(undefined);
    if (configId !== undefined) {
        element.setAttribute("data-config", configId);
        element.setAttribute("data-namespace", "alt");
        element.setAttribute("data-auto-namespace", "false");
    }
    return element;
}
function $9fdf7c0153f60f3f$export$c8603593494de511(param) {
    var localhost = $2whNH.isSome($loT9g.nullable_to_opt(document.querySelector('script[src^="http://localhost:8787/optimize.js?id="]')));
    var production = $2whNH.isSome($loT9g.nullable_to_opt(document.querySelector('script[src^="https://embed.maker.co/optimize.js?id="]')));
    var host = localhost ? "http://localhost:6007" : production ? "https://showside.maker.co" : window.location.origin;
    var script = document.createElement("script");
    script.setAttribute("src", host + "/smartnav-v2.js");
    $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
        param.appendChild(script);
    });
}
function $9fdf7c0153f60f3f$export$4289ce05efcce874(variant) {
    return $9fdf7c0153f60f3f$var$_updateAltFunnelVariant.apply(this, arguments);
}
function $9fdf7c0153f60f3f$var$_updateAltFunnelVariant() {
    $9fdf7c0153f60f3f$var$_updateAltFunnelVariant = (0, $5YOUh._)(function(variant) {
        var variantValue, variantIsProductAltFunnel, variantIsCollectionAltFunnel, match, match$1, variant$1, match$2, match$3, variant$2, exit, variantId, value, value$1, value$2;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    variantValue = $2whNH.mapWithDefault(variant.value, variant.targetId, function(v) {
                        return v;
                    });
                    variantIsProductAltFunnel = $2whNH.getWithDefault(variantValue, "").includes("QNProductId__alt=...");
                    variantIsCollectionAltFunnel = $2whNH.getWithDefault(variantValue, "").includes("QNView__alt=category%3A...");
                    match = $2whNH.isSome($9fdf7c0153f60f3f$export$606c153358defcb8(undefined));
                    match$1 = variantIsProductAltFunnel || variantIsCollectionAltFunnel;
                    variant$1 = match && match$1 ? ($ceAXu.log2("already in alt funnel, skipping", {
                        variant: variant.targetId,
                        value: variantValue
                    }), undefined) : variant;
                    if (!variantIsProductAltFunnel) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $cdK26.waitForShopifyAnalytics(undefined, undefined)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    if (!variantIsCollectionAltFunnel) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $cdK26.waitForShopifyAnalytics(undefined, undefined)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    match$2 = $cdK26.getProductPageProductId(undefined);
                    match$3 = $cdK26.getCollectionPageCollectionId(undefined);
                    if (variant$1 === undefined) return [
                        2,
                        variant$1
                    ];
                    exit = 0;
                    if (variantIsProductAltFunnel) {
                        if (match$2 !== undefined) {
                            $ceAXu.log2("alt funnel matched", {
                                variant: variant$1.targetId,
                                value: variantValue,
                                productId: match$2,
                                variantId: $cdK26.getProductPageVariantId(undefined)
                            });
                            variantId = $cdK26.getProductPageVariantId(undefined);
                            value = variantId !== undefined ? $2whNH.map(variantValue, function(__x) {
                                return __x.replace("QNProductId__alt=...", "QNProductId__alt=...&QNVariantId__alt=" + variantId + "");
                            }) : variantValue;
                            value$1 = $2whNH.map(value, function(__x) {
                                return __x.replace("QNProductId__alt=...", "QNProductId__alt=" + match$2 + "");
                            });
                            return [
                                2,
                                {
                                    targetId: variant$1.targetId,
                                    target: variant$1.target,
                                    value: value$1,
                                    targetType: variant$1.targetType,
                                    splitRange: variant$1.splitRange,
                                    createdAt: variant$1.createdAt,
                                    updatedAt: variant$1.updatedAt,
                                    trackingId: variant$1.trackingId
                                }
                            ];
                        }
                        exit = 2;
                    } else exit = 2;
                    if (exit === 2) {
                        if (variantIsCollectionAltFunnel) {
                            if (match$3 !== undefined) {
                                $ceAXu.log2("alt funnel matched", {
                                    variant: variant$1.targetId,
                                    value: variantValue,
                                    collectionId: match$3
                                });
                                value$2 = $2whNH.map(variantValue, function(__x) {
                                    return __x.replace("QNView__alt=category%3A...", "QNView__alt=category%3A" + match$3 + "");
                                });
                                return [
                                    2,
                                    {
                                        targetId: variant$1.targetId,
                                        target: variant$1.target,
                                        value: value$2,
                                        targetType: variant$1.targetType,
                                        splitRange: variant$1.splitRange,
                                        createdAt: variant$1.createdAt,
                                        updatedAt: variant$1.updatedAt,
                                        trackingId: variant$1.trackingId
                                    }
                                ];
                            }
                            variant$2 = variant$1;
                        } else {
                            if (!variantIsProductAltFunnel) return [
                                2,
                                variant$1
                            ];
                            variant$2 = variant$1;
                        }
                    }
                    $ceAXu.log2("alt funnel matched but Shopify product or collection ID not found", {
                        variant: variant$2.targetId,
                        value: variantValue
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return $9fdf7c0153f60f3f$var$_updateAltFunnelVariant.apply(this, arguments);
}
 /* WebapiUtils-Showside Not a pure module */ 
});
parcelRegister("ceAXu", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $8e83760a6de60d84$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "log2", function () { return $8e83760a6de60d84$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "Tap", function () { return $8e83760a6de60d84$export$4451a18ddc7083b7; });
$parcel$export(module.exports, "getResults", function () { return $8e83760a6de60d84$export$7e34e99eb2ee781b; });
$parcel$export(module.exports, "getWinners", function () { return $8e83760a6de60d84$export$e32b26a24de8363f; });
$parcel$export(module.exports, "logResults", function () { return $8e83760a6de60d84$export$c239fdd1aa3794db; });
$parcel$export(module.exports, "logFacts", function () { return $8e83760a6de60d84$export$23da166c95567064; });
$parcel$export(module.exports, "logWinner", function () { return $8e83760a6de60d84$export$f9219c011d6cc400; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $8e83760a6de60d84$export$69c04c4d1084c9c8(msg) {
    return "[nav optimize] " + msg;
}
function $8e83760a6de60d84$export$220b4a817d498a2f(param) {
    return $7bjme.equal($loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get("maker_logs")), "true");
}
function $8e83760a6de60d84$export$bef1f36f5486a6a3(msg) {
    if ($8e83760a6de60d84$export$220b4a817d498a2f(undefined)) {
        console.log("[nav optimize] " + msg);
        return;
    }
}
function $8e83760a6de60d84$export$b9fae0bba9d9094d(msg, data) {
    if ($8e83760a6de60d84$export$220b4a817d498a2f(undefined)) {
        console.log("[nav optimize] " + msg, data);
        return;
    }
}
function $8e83760a6de60d84$var$tap(data, fn) {
    $iv6Yc._1(fn, data);
    return data;
}
function $8e83760a6de60d84$var$log2$1(data, msg) {
    $8e83760a6de60d84$export$b9fae0bba9d9094d(msg, data);
    return data;
}
var $8e83760a6de60d84$export$4451a18ddc7083b7 = {
    tap: $8e83760a6de60d84$var$tap,
    log2: $8e83760a6de60d84$var$log2$1
};
function $8e83760a6de60d84$export$7e34e99eb2ee781b(param) {
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(window.maker_optimize, function(prim) {
        return prim.results;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), {});
}
function $8e83760a6de60d84$export$e32b26a24de8363f(param) {
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(window.maker_optimize, function(prim) {
        return prim.winners;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), []);
}
function $8e83760a6de60d84$export$41b63253271a577a(param) {
    window.dispatchEvent(new Event("makerOptimizeUpdate"));
}
function $8e83760a6de60d84$export$c239fdd1aa3794db(experimentId, clearOpt, results) {
    var clear = clearOpt !== undefined ? clearOpt : false;
    var current = $8e83760a6de60d84$export$7e34e99eb2ee781b(undefined);
    var currentExperiment = $2whNH.getWithDefault($d3YYW.get(current, experimentId), []);
    var currentExperimentWinner = $i7mYY.concatMany($i7mYY.map(currentExperiment, function(results) {
        return $i7mYY.concat($2whNH.getWithDefault(results.conditions.all, []), $2whNH.getWithDefault(results.conditions.any, []));
    }));
    var newResults = $i7mYY.concatMany($i7mYY.map(results, function(results) {
        return $i7mYY.concat($2whNH.getWithDefault(results.conditions.all, []), $2whNH.getWithDefault(results.conditions.any, []));
    }));
    var currentExperimentWinner$1 = currentExperimentWinner.length !== 0 && currentExperimentWinner.length > newResults.length && $i7mYY.reduce(currentExperimentWinner, true, function(acc, result) {
        if (acc) return result.result;
        else return false;
    });
    if (!currentExperimentWinner$1) {
        var currentExperiment$1 = clear ? [] : currentExperiment;
        current[experimentId] = $i7mYY.concat(currentExperiment$1, results);
        $2whNH.forEach(window.maker_optimize, function(__x) {
            __x.results = current;
        });
    }
    $8e83760a6de60d84$export$41b63253271a577a(undefined);
}
function $8e83760a6de60d84$export$23da166c95567064(facts) {
    $2whNH.forEach(window.maker_optimize, function(__x) {
        __x.facts = facts;
    });
}
function $8e83760a6de60d84$export$f9219c011d6cc400(experimentId, reason, variantId) {
    var current = $8e83760a6de60d84$export$e32b26a24de8363f(undefined);
    var exists = $i7mYY.some(current, function(winner) {
        if ($7bjme.equal(winner.experimentId, experimentId) && winner.variantId === variantId) return $7bjme.equal(winner.reason, reason);
        else return false;
    });
    if (exists) return;
    var winners = $i7mYY.concat(current, [
        {
            experimentId: experimentId,
            variantId: variantId,
            reason: reason
        }
    ]);
    $2whNH.forEach(window.maker_optimize, function(__x) {
        __x.winners = winners;
    });
    $8e83760a6de60d84$export$41b63253271a577a(undefined);
}
 /* No side effect */ 
});

parcelRegister("cdK26", function(module, exports) {

$parcel$export(module.exports, "initialDocumentCookie", function () { return $8e5a681fe8edbb44$export$6d8a53c95d62f16a; });
$parcel$export(module.exports, "waitForShopifyAnalytics", function () { return $8e5a681fe8edbb44$export$f84603f07eeb1d63; });
$parcel$export(module.exports, "getProductPageProductId", function () { return $8e5a681fe8edbb44$export$655ef3e62ebfeb40; });
$parcel$export(module.exports, "getCollectionPageCollectionId", function () { return $8e5a681fe8edbb44$export$1ccfc961cba0f1c6; });
$parcel$export(module.exports, "getProductPageVariantId", function () { return $8e5a681fe8edbb44$export$cc267c015bc8901b; });
$parcel$export(module.exports, "isProductPage", function () { return $8e5a681fe8edbb44$export$a6ee0f0139d9689a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");
function $8e5a681fe8edbb44$var$fromMeta(meta) {
    var page = meta.page;
    var page$1 = page == null ? undefined : $loT9g.some(page);
    var product = meta.product;
    var resourceId = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceId;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    var resourceType = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceType;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    if (resourceType === undefined) return;
    switch(resourceType){
        case "collection":
            if (resourceId !== undefined) return {
                TAG: /* CollectionPage */ 0,
                collectionId: resourceId.toString()
            };
            else return;
        case "product":
            if (resourceId !== undefined) return {
                TAG: /* ProductPage */ 1,
                productId: resourceId.toString(),
                variants: $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(product == null ? undefined : $loT9g.some(product), function(prim) {
                    return prim.variants;
                }), function(prim) {
                    if (prim == null) return;
                    else return $loT9g.some(prim);
                }), [])
            };
            else return;
        default:
            return;
    }
}
var $8e5a681fe8edbb44$export$6955bcca4cd3539f = {
    fromMeta: $8e5a681fe8edbb44$var$fromMeta
};
function $8e5a681fe8edbb44$export$6d8a53c95d62f16a(param) {
    return $2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.lib;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.config;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.initialDocumentCookie;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
}
function $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCountOpt, param) {
    var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
    var match = window.ShopifyAnalytics;
    var match$1 = retryCount > 25;
    if (!(match == null) || match$1) return Promise.resolve(undefined);
    else return new Promise(function(resolve, reject) {
        setTimeout(function(param) {
            $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCount + 1 | 0, undefined).then(function(result) {
                resolve(result);
            });
        }, 42);
    });
}
function $8e5a681fe8edbb44$export$c2a6433281518c91(param) {
    return $2whNH.flatMap($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.meta;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), $8e5a681fe8edbb44$var$fromMeta);
}
function $8e5a681fe8edbb44$export$655ef3e62ebfeb40(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return;
        else return page.productId;
    });
}
function $8e5a681fe8edbb44$export$1ccfc961cba0f1c6(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return page.collectionId;
    });
}
function $8e5a681fe8edbb44$export$cc267c015bc8901b(param) {
    var variants = $2whNH.mapWithDefault($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), [], function(page) {
        if (page.TAG === /* CollectionPage */ 0) return [];
        else return page.variants;
    });
    var idToFind = $bygWp.getParam(window.location.href, "variant");
    var foundVariant = idToFind !== undefined ? $i7mYY.getBy(variants, function(v) {
        var currentId = $2whNH.map($loT9g.nullable_to_opt(v.id), function(prim) {
            return prim.toString();
        });
        return $7bjme.equal(currentId, idToFind);
    }) : undefined;
    var firstVariant = $i7mYY.get(variants, 0);
    return $2whNH.map($2whNH.flatMap($2whNH.map($2whNH.orElse(foundVariant, firstVariant), function(prim) {
        return prim.id;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.toString();
    });
}
function $8e5a681fe8edbb44$export$a6ee0f0139d9689a(param) {
    return $2whNH.isSome($8e5a681fe8edbb44$export$655ef3e62ebfeb40(undefined));
}
 /* No side effect */ 
});


parcelRegister("d86AX", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $98f1235c5293f03c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $heivG = parcelRequire("heivG");

var $16qP0 = parcelRequire("16qP0");

var $bN6o7 = parcelRequire("bN6o7");

var $1xf0g = parcelRequire("1xf0g");

var $ib4c4 = parcelRequire("ib4c4");

var $IFWJb = parcelRequire("IFWJb");

var $3gZOF = parcelRequire("3gZOF");

var $fvE4w = parcelRequire("fvE4w");

var $gFKzh = parcelRequire("gFKzh");

var $gO2mJ = parcelRequire("gO2mJ");

var $i6QHm = parcelRequire("i6QHm");

var $ePRCc = parcelRequire("ePRCc");

var $4j4tH = parcelRequire("4j4tH");

var $ib2AA = parcelRequire("ib2AA");

var $3xYJl = parcelRequire("3xYJl");

var $5bEXW = parcelRequire("5bEXW");

var $8L1B1 = parcelRequire("8L1B1");

var $46DBn = parcelRequire("46DBn");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $lBn5n = parcelRequire("lBn5n");

var $2ZaET = parcelRequire("2ZaET");

var $lihS4 = parcelRequire("lihS4");

var $6e14p = parcelRequire("6e14p");

var $dhngN = parcelRequire("dhngN");

var $8Esoa = parcelRequire("8Esoa");

var $8adqh = parcelRequire("8adqh");

var $fCgIf = parcelRequire("fCgIf");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");

var $1CxxQ = parcelRequire("1CxxQ");

var $eZ1bL = parcelRequire("eZ1bL");

var $g3aLS = parcelRequire("g3aLS");

var $gtaS4 = parcelRequire("gtaS4");

var $hM6fK = parcelRequire("hM6fK");

var $jQE31 = parcelRequire("jQE31");

var $6EwcS = parcelRequire("6EwcS");

var $gUsPc = parcelRequire("gUsPc");

var $ij6do = parcelRequire("ij6do");
function $98f1235c5293f03c$var$InlineApp$MkrBioEscapeKeyControllerWrapper(Props) {
    var children = Props.children;
    var match = $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined).config;
    var categories = match$1.categories;
    var isMkrBioEnabled = match$1.settings.mkrBio !== undefined;
    var match$2 = $2whNH.getWithDefault($i7mYY.get(categories, 0), $ij6do.empty);
    var activeCategoryId = $2whNH.map($hBcYV.useActiveCategory(undefined, undefined, categories), function(c) {
        return c.id;
    });
    var isFirstCategory = $7bjme.equal(match$2.id, activeCategoryId);
    var isTopLevelCategory = $i7mYY.some(categories, function(cat) {
        return $7bjme.equal(cat.id, activeCategoryId);
    });
    var isListPage;
    var tmp = match.route;
    isListPage = typeof tmp === "number" || tmp.TAG !== /* ListPage */ 1 ? false : true;
    $bN6o7.use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Escape", function(param) {
        if (isMkrBioEnabled && !isFirstCategory && isTopLevelCategory && isListPage) {
            $gO2mJ.back($gO2mJ.history);
            return;
        }
    });
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !isMkrBioEnabled || !isTopLevelCategory || !isListPage,
        children: children
    });
}
$98f1235c5293f03c$var$InlineApp$MkrBioEscapeKeyControllerWrapper.displayName = "InlineApp.MkrBioEscapeKeyControllerWrapper";
var $98f1235c5293f03c$export$2dd7d8294c1d88d7 = {
    make: $98f1235c5293f03c$var$InlineApp$MkrBioEscapeKeyControllerWrapper
};
function $98f1235c5293f03c$var$InlineApp$ContextualInlineRouterWrapper(Props) {
    var embedType = Props.embedType;
    var configId = Props.configId;
    var children = Props.children;
    var contextualRoot = $lBn5n.useContextualRoot(/* Open */ 2, embedType, window.location.pathname);
    var defaultInitialRoute = $2whNH.mapWithDefault(contextualRoot, {
        TAG: /* Home */ 0,
        _0: {
            homeType: /* Index */ 0,
            filters: undefined,
            sort: undefined
        }
    }, function(root) {
        var isPLP = $1xf0g.isPLP(root);
        var id = root.id;
        return {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: id
                },
                viewPLP: isPLP,
                filters: undefined,
                sort: undefined
            }
        };
    });
    return /*#__PURE__*/ $g85JO.createElement($hBcYV.make, {
        configId: configId,
        defaultInitialRoute: defaultInitialRoute,
        embedType: embedType,
        children: children
    });
}
$98f1235c5293f03c$var$InlineApp$ContextualInlineRouterWrapper.displayName = "InlineApp.ContextualInlineRouterWrapper";
var $98f1235c5293f03c$export$a907c13eabcfb2d1 = {
    make: $98f1235c5293f03c$var$InlineApp$ContextualInlineRouterWrapper
};
function $98f1235c5293f03c$var$InlineApp$Content(Props) {
    var scrollableContainerRef = Props.scrollableContainerRef;
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    $lihS4.useCart(undefined);
    $aSJcu.use(undefined);
    var globalScrollRestorationBoundaryRef = $g85JO.useRef(null);
    var match = $hBcYV.useRouter(undefined);
    var quickViewUnderlyingRoute = match.quickViewUnderlyingRoute;
    var route = match.route;
    $efwy1.use(undefined);
    var match$1 = $8E2YL.use(undefined);
    var config = match$1.config;
    var trackEvent = $gFKzh.use(embedType);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, config.categories);
    $g85JO.useEffect(function() {
        $iv6Yc.app(trackEvent, [
            "open",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        if (activeCategory !== undefined) $iv6Yc.app(trackEvent, [
            "top category nav",
            true,
            activeCategory,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        else if (typeof route !== "number" && route.TAG === /* Home */ 0) $iv6Yc.app(trackEvent, [
            "open index",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    }, []);
    var anchorHookResult = $3gZOF.useAnchors(undefined, undefined);
    var tmp = {
        config: config,
        embedType: embedType,
        children: null
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    var tmp$1;
    var exit = 0;
    var exit$1 = 0;
    var exit$2 = 0;
    if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */ 2)) exit = 2;
    else exit$2 = 5;
    if (exit$2 === 5) {
        if (typeof route === "number") exit$1 = 4;
        else switch(route.TAG | 0){
            case /* Home */ 0:
            case /* ListPage */ 1:
                exit = 3;
                break;
            case /* PDP */ 2:
                exit = 2;
                break;
            case /* QuickView */ 3:
                exit$1 = 4;
                break;
        }
    }
    if (exit$1 === 4) {
        if (quickViewUnderlyingRoute !== undefined && typeof quickViewUnderlyingRoute !== "number") switch(quickViewUnderlyingRoute.TAG | 0){
            case /* Home */ 0:
            case /* ListPage */ 1:
                exit = 3;
                break;
            case /* QuickView */ 3:
                exit = 1;
                break;
        }
        else exit = 1;
    }
    switch(exit){
        case 1:
            tmp$1 = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex-grow")
            });
            break;
        case 2:
            tmp$1 = /*#__PURE__*/ $g85JO.createElement($hM6fK.make, {});
            break;
        case 3:
            var tmp$2;
            var exit$3 = 0;
            var exit$4 = 0;
            if (quickViewUnderlyingRoute !== undefined) {
                if (typeof quickViewUnderlyingRoute === "number") exit$3 = 4;
                else switch(quickViewUnderlyingRoute.TAG | 0){
                    case /* PDP */ 2:
                    case /* QuickView */ 3:
                        exit$4 = 5;
                        break;
                    default:
                        exit$3 = 4;
                }
            } else exit$4 = 5;
            if (exit$4 === 5) {
                if (typeof route === "number") exit$3 = 4;
                else switch(route.TAG | 0){
                    case /* PDP */ 2:
                    case /* QuickView */ 3:
                        tmp$2 = null;
                        break;
                    default:
                        exit$3 = 4;
                }
            }
            if (exit$3 === 4) tmp$2 = /*#__PURE__*/ $g85JO.createElement($heivG.make, {
                drawerState: /* Open */ 2,
                embedType: embedType
            });
            tmp$1 = /*#__PURE__*/ $g85JO.createElement($ib4c4.make, {
                scrollableContainerRef: scrollableContainerRef,
                drawerState: /* Open */ 2,
                anchorHookResult: anchorHookResult,
                children: tmp$2
            });
            break;
    }
    var tmp$3;
    tmp$3 = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? null : /*#__PURE__*/ $g85JO.createElement($b8WNX.make, {});
    return /*#__PURE__*/ $g85JO.createElement($1CxxQ.Provider.make, {
        embedRef: globalScrollRestorationBoundaryRef,
        children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp, /*#__PURE__*/ $g85JO.createElement($98f1235c5293f03c$var$InlineApp$MkrBioEscapeKeyControllerWrapper, {
            children: /*#__PURE__*/ $g85JO.createElement($8Esoa.make, {
                embedType: embedType
            })
        }), /*#__PURE__*/ $g85JO.createElement($fvE4w.Provider.make, {
            value: /* Open */ 2,
            children: null
        }, /*#__PURE__*/ $g85JO.createElement($2ZaET.OptionMap.make, {
            option: config.settings.mkrBio,
            children: function children(mkrBio) {
                return /*#__PURE__*/ $g85JO.createElement($3xYJl.make, {
                    config: mkrBio
                });
            }
        }), /*#__PURE__*/ $g85JO.createElement($jQE31.make, {
            onChange: function onChange(param) {
                $iv6Yc._1(anchorHookResult.setOffset, param.anchorsOffset);
            },
            children: null
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(globalScrollRestorationBoundaryRef)
        }, tmp$1), tmp$3), /*#__PURE__*/ $g85JO.createElement($2ZaET.OptionMap.make, {
            option: config.transitiveAccount,
            condition: function condition(account) {
                if ($2whNH.isSome(config.settings.mkrBio)) return account.showPoweredByMaker;
                else return false;
            },
            children: function children(param) {
                return /*#__PURE__*/ $g85JO.createElement($ib2AA.make, {});
            }
        }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: config.settings.cart,
            children: /*#__PURE__*/ $g85JO.createElement($8adqh.make, {})
        })))
    });
}
$98f1235c5293f03c$var$InlineApp$Content.displayName = "InlineApp.Content";
var $98f1235c5293f03c$var$make = /*#__PURE__*/ $g85JO.memo($98f1235c5293f03c$var$InlineApp$Content);
var $98f1235c5293f03c$export$7c6e2c02157bb7d2 = {
    make: $98f1235c5293f03c$var$make
};
function $98f1235c5293f03c$var$InlineApp$App(Props) {
    var configId = Props.configId;
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var entrypointRef = $g85JO.useRef(null);
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var isStyleLoaded = $6e14p.useIsStyleLoaded(undefined);
    $hBcYV.useRouter(undefined);
    var scrollableContainerRef = $g85JO.useRef(null);
    var match$1 = $16qP0.use(undefined);
    var smartnavApiHost = match$1.smartnavApiHost;
    var addToCart = $46DBn.useAddToCart(configId, smartnavApiHost);
    var pictureInPicture = config.settings.quickviewPictureInPicture;
    var tmp = {
        configId: configId,
        addToCart: addToCart,
        entrypointRef: entrypointRef,
        scrollableContainerRef: scrollableContainerRef,
        smartnavApiHost: smartnavApiHost,
        embedType: embedType
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    var content = /*#__PURE__*/ $g85JO.createElement($98f1235c5293f03c$var$make, tmp);
    var component = /*#__PURE__*/ $g85JO.createElement($8L1B1.make, {
        config: config,
        children: /*#__PURE__*/ $g85JO.createElement($IFWJb.Provider.make, {
            children: /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: pictureInPicture,
                children: /*#__PURE__*/ $g85JO.createElement($gtaS4.make, {
                    children: null
                }, content, /*#__PURE__*/ $g85JO.createElement($eZ1bL.make, {})),
                fallback: content
            })
        })
    });
    return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "inline",
        portal: false,
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($i6QHm.make, {
        embedType: embedType
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: isStyleLoaded,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(entrypointRef)
        }, component)
    }));
}
$98f1235c5293f03c$var$InlineApp$App.displayName = "InlineApp.App";
var $98f1235c5293f03c$var$make$1 = /*#__PURE__*/ $g85JO.memo($98f1235c5293f03c$var$InlineApp$App);
var $98f1235c5293f03c$export$86fbec116b87613f = {
    make: $98f1235c5293f03c$var$make$1
};
function $98f1235c5293f03c$var$InlineApp(Props) {
    var configId = Props.configId;
    var embedType = Props.embedType;
    var attributes = Props.attributes;
    var match = $hBcYV.useRouter(undefined);
    var previewMode = match.previewMode;
    var match$1 = $8E2YL.use(undefined);
    var config = match$1.config;
    var tmp = {
        configId: configId,
        embedType: embedType
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    var tmp$1 = {
        children: /*#__PURE__*/ $g85JO.createElement($g3aLS.make, {
            children: /*#__PURE__*/ $g85JO.createElement($98f1235c5293f03c$var$make$1, tmp)
        })
    };
    if (attributes !== undefined) tmp$1.attributes = $loT9g.valFromOption(attributes);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: $7bjme.notequal(previewMode, /* PreviewLive */ 1) && previewMode !== undefined,
        children: /*#__PURE__*/ $g85JO.createElement($4j4tH.make, {})
    }), /*#__PURE__*/ $g85JO.createElement($6EwcS.make, {
        configId: config.id,
        accountId: config.accountId,
        historyEnabled: config.settings.historyEnabled,
        favoritesEnabled: config.settings.favoritesEnabled,
        children: /*#__PURE__*/ $g85JO.createElement($98f1235c5293f03c$var$InlineApp$ContextualInlineRouterWrapper, {
            embedType: embedType,
            attributes: attributes,
            configId: configId,
            children: /*#__PURE__*/ $g85JO.createElement($fCgIf.make, {
                attributes: attributes,
                embedType: embedType,
                children: /*#__PURE__*/ $g85JO.createElement($lihS4.make, {
                    children: /*#__PURE__*/ $g85JO.createElement($gUsPc.make, tmp$1)
                })
            })
        })
    }));
}
$98f1235c5293f03c$var$InlineApp.displayName = "InlineApp";
var $98f1235c5293f03c$export$dd44f18ab656f3bb = $98f1235c5293f03c$var$InlineApp;
var $98f1235c5293f03c$export$aa541d093b11ace2 = $98f1235c5293f03c$var$InlineApp;
 /* make Not a pure module */ 
});
parcelRegister("ib4c4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d3bc81d59ddd1330$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $hBcYV = parcelRequire("hBcYV");

var $9YpHb = parcelRequire("9YpHb");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $h4qog = parcelRequire("h4qog");
function $d3bc81d59ddd1330$var$ListPage(Props) {
    var scrollableContainerRef = Props.scrollableContainerRef;
    var drawerState = Props.drawerState;
    var anchorHookResult = Props.anchorHookResult;
    var children = Props.children;
    var match = $9pMGg.use(undefined);
    var match$1 = $8E2YL.use(undefined);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, match$1.config.categories);
    var tmp = {
        scrollableContainerRef: scrollableContainerRef,
        isSidebarOpen: match.isSidebarOpen,
        isMobileFiltersOpen: match.isMobileFiltersOpen
    };
    if (activeCategory !== undefined) tmp.activeCategory = $loT9g.valFromOption(activeCategory);
    if (anchorHookResult !== undefined) tmp.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
    var tmp$1 = {
        scrollableContainerRef: scrollableContainerRef,
        drawerState: drawerState,
        listPageContent: /*#__PURE__*/ $g85JO.createElement($9YpHb.make, tmp),
        children: children
    };
    if (anchorHookResult !== undefined) tmp$1.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
    return /*#__PURE__*/ $g85JO.createElement($h4qog.make, tmp$1);
}
$d3bc81d59ddd1330$var$ListPage.displayName = "ListPage";
var $d3bc81d59ddd1330$export$dd44f18ab656f3bb = $d3bc81d59ddd1330$var$ListPage;
 /* react Not a pure module */ 
});

parcelRegister("fvE4w", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $b4a8d5b63998f43c$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "Provider", function () { return $b4a8d5b63998f43c$export$2881499e37b75b9a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");
function $b4a8d5b63998f43c$export$1f96ae73734a86cc(param) {
    var match = $g85JO.useState(function() {
        return /* Closed */ 0;
    });
    var setState = match[1];
    var stateRef = $g85JO.useRef(/* Closed */ 0);
    var handleChange = function handleChange(next) {
        $iv6Yc._1(setState, function(param) {
            return next;
        });
        stateRef.current = next;
    };
    var onClose = function onClose(param) {
        handleChange(/* Closed */ 0);
    };
    var onOpen = function onOpen(param) {
        handleChange(/* Open */ 2);
    };
    var onOpening = function onOpening(param) {
        handleChange(/* Opening */ 1);
    };
    return {
        state: match[0],
        stateRef: stateRef,
        onOpening: onOpening,
        onOpen: onOpen,
        onClose: onClose
    };
}
var $b4a8d5b63998f43c$var$context = /*#__PURE__*/ $g85JO.createContext(/* Closed */ 0);
var $b4a8d5b63998f43c$var$provider = $b4a8d5b63998f43c$var$context.Provider;
function $b4a8d5b63998f43c$var$DrawerState$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($b4a8d5b63998f43c$var$provider, {
        value: value,
        children: children
    });
}
$b4a8d5b63998f43c$var$DrawerState$Provider.displayName = "DrawerState.Provider";
function $b4a8d5b63998f43c$var$use$1(param) {
    return $g85JO.useContext($b4a8d5b63998f43c$var$context);
}
var $b4a8d5b63998f43c$export$2881499e37b75b9a = {
    context: $b4a8d5b63998f43c$var$context,
    provider: $b4a8d5b63998f43c$var$provider,
    make: $b4a8d5b63998f43c$var$DrawerState$Provider,
    use: $b4a8d5b63998f43c$var$use$1
};
 /* context Not a pure module */ 
});

parcelRegister("i6QHm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d2f1aa58c533da63$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $9rqV0 = parcelRequire("9rqV0");

var $b5aRK = parcelRequire("b5aRK");

var $iCVlB = parcelRequire("iCVlB");
function $d2f1aa58c533da63$var$AdditionalCSS(Props) {
    var embedType = Props.embedType;
    var getIsNavBeingHiddenWithDisplayNone = function getIsNavBeingHiddenWithDisplayNone(param) {
        return $i7mYY.every($i7mYY.map($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll("#" + $9rqV0.getIdByEmbedType(embedType))), $b5aRK.ofNode), function(node) {
            return $2whNH.map(node, function(node) {
                return window.getComputedStyle(node).display;
            });
        }), function(display) {
            return $7bjme.equal(display, "none");
        });
    };
    var match = $g85JO.useState(function() {
        return getIsNavBeingHiddenWithDisplayNone(undefined);
    });
    var setIsNavBeingHiddenWithDisplayNone = match[1];
    $g85JO.useLayoutEffect(function() {
        $iv6Yc._1(setIsNavBeingHiddenWithDisplayNone, function(param) {
            return getIsNavBeingHiddenWithDisplayNone(undefined);
        });
    });
    if (match[0]) return null;
    else return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("style", undefined, "html[lang='en'].QVTW__body-no-scroll body,\n        html.QVTW__body-no-scroll,\n        html[lang='en'].QVTW__body-no-scroll body.production,\n        html.QVTW__body-no-scroll,\n        html.QVTW__body-no-scroll body {\n          overflow: clip !important;\n          overflow-x: clip !important;\n          overflow-y: clip !important;\n          touch-action: none;\n        }\n\n        html.QVTW__body-no-scroll .js-maker-embed[data-sticky] iframe {\n          display: none !important;\n        }"), /*#__PURE__*/ $g85JO.createElement($iCVlB.CustomStyling.make, {}));
}
$d2f1aa58c533da63$var$AdditionalCSS.displayName = "AdditionalCSS";
var $d2f1aa58c533da63$export$dd44f18ab656f3bb = $d2f1aa58c533da63$var$AdditionalCSS;
 /* react Not a pure module */ 
});

parcelRegister("4j4tH", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $322c68ffe6f8f794$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $baORH = parcelRequire("baORH");

var $i7mYY = parcelRequire("i7mYY");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $322c68ffe6f8f794$var$EditorMethods(Props) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var route = match$1.route;
    $baORH.IFrame.useCommandReceiver(undefined, /* RefreshConfig */ 2, function(param) {
        return Promise.all($i7mYY.map($i7mYY.keep(Array.from($2gEz2.Cache.cache.keys()), function(key) {
            return key.includes("/api/get_config");
        }), $2gEz2.revalidate));
    }, []);
    $baORH.IFrame.useCommandReceiver(undefined, /* Open */ 3, function(param) {
        if (typeof route === "number") return $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* Home */ 0,
            _0: {
                homeType: /* Index */ 0,
                filters: undefined,
                sort: undefined
            }
        });
    }, [
        config.id
    ]);
    $g85JO.useEffect(function() {
        $baORH.IFrame.sendCommand0(undefined, /* Ready */ 0);
        return function(param) {
            $baORH.IFrame.sendCommand0(undefined, /* Destroyed */ 1);
        };
    }, [
        config.id
    ]);
    return null;
}
$322c68ffe6f8f794$var$EditorMethods.displayName = "EditorMethods";
var $322c68ffe6f8f794$export$dd44f18ab656f3bb = $322c68ffe6f8f794$var$EditorMethods;
 /* SWR Not a pure module */ 
});

parcelRegister("ib2AA", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d3bb4332c35965f3$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $ePRCc = parcelRequire("ePRCc");

var $5bEXW = parcelRequire("5bEXW");

var $9pMGg = parcelRequire("9pMGg");

var $ifGoD = parcelRequire("ifGoD");

var $iJp5F = parcelRequire("iJp5F");

var $8E2YL = parcelRequire("8E2YL");
function $d3bb4332c35965f3$var$MadeWithMaker(Props) {
    var link = "https://mkr.bio/?utm_medium=referral&utm_source=mkr.bio&utm_campaign=madeinmakerb";
    var ref = $g85JO.useRef(null);
    $8E2YL.use(undefined).config;
    var match = $g85JO.useState(function() {
        return true;
    });
    var setShowFixedWatermark = match[1];
    var intersection = $iJp5F.use(ref, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    var match$1 = $9pMGg.use(undefined);
    var trackEvent = match$1.trackEvent;
    var onClick = function onClick(param) {
        $iv6Yc.app(trackEvent, [
            "mkrbio:made_with_maker",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    $g85JO.useEffect(function() {
        $iv6Yc._1(setShowFixedWatermark, function(param) {
            return !intersection.isIntersecting;
        });
    }, [
        intersection.isIntersecting
    ]);
    var watermarkContent = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($ifGoD.make, {
        className: $ezf3v.prefix("w-36")
    }));
    var commonCn = $1TRFX.make([
        "flex items-center justify-center",
        "space-x-1.5",
        "bg-white text-gray-500",
        "hover:text-black",
        "text-base"
    ]);
    var className = $ezf3v.prefix($1TRFX.make([
        commonCn,
        "h-12 w-full",
        "-mt-12"
    ]));
    var relativeWatermark = /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(ref),
            className: className
        }, watermarkContent),
        href: link,
        unstyled: true,
        className: $ezf3v.prefix("no-underline relative"),
        dataTestId: "made-with-maker-watermark",
        onClick: onClick
    });
    var className$1 = $ezf3v.prefix($1TRFX.make([
        commonCn,
        "py-2 px-3",
        "fixed right-0 bottom-0",
        "rounded-l-sm",
        "transform",
        match[0] ? "translate-y-0" : "translate-y-full",
        "transition-transform duration-300"
    ]));
    var fixedWatermark = /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: className$1,
            style: {
                zIndex: "2147483647"
            }
        }, watermarkContent),
        href: link,
        unstyled: true,
        dataTestId: "made-with-maker-watermark",
        onClick: onClick
    });
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, relativeWatermark, /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "maker-watermark",
        portal: true,
        children: fixedWatermark
    }));
}
$d3bb4332c35965f3$var$MadeWithMaker.displayName = "MadeWithMaker";
var $d3bb4332c35965f3$export$dd44f18ab656f3bb = $d3bb4332c35965f3$var$MadeWithMaker;
var $d3bb4332c35965f3$export$aa541d093b11ace2 = $d3bb4332c35965f3$var$MadeWithMaker;
 /* react Not a pure module */ 
});
parcelRegister("ifGoD", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d49a83c0facdfaad$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $d49a83c0facdfaad$var$IconMadeWithMaker(Props) {
    var className = Props.className;
    var tmp = {
        viewBox: "0 0 113.45 9.22",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("g", undefined, /*#__PURE__*/ $g85JO.createElement("g", undefined, /*#__PURE__*/ $g85JO.createElement("polygon", {
        fill: "currentColor",
        points: "4.48 7.13 4.38 7.13 1.6 .35 0 .35 0 9.08 1.25 9.08 1.25 2.76 1.33 2.76 3.91 9.06 4.95 9.06 7.52 2.76 7.6 2.76 7.6 9.08 8.86 9.08 8.86 .35 7.26 .35 4.48 7.13"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M14.92,2.87c-.26-.16-.53-.27-.83-.33-.29-.06-.57-.09-.83-.09-.39,0-.77,.06-1.13,.17-.36,.11-.67,.29-.95,.54-.27,.24-.48,.57-.62,.96l1.2,.27c.09-.23,.26-.44,.51-.63,.25-.19,.59-.29,1.01-.29s.72,.1,.93,.31c.21,.2,.32,.49,.32,.87v.03c0,.15-.06,.26-.17,.33s-.29,.12-.53,.15c-.24,.03-.56,.07-.95,.11-.31,.04-.61,.09-.91,.16-.3,.07-.57,.18-.81,.32-.24,.14-.43,.33-.58,.57-.14,.24-.21,.54-.21,.91,0,.43,.1,.79,.29,1.09,.2,.3,.46,.52,.8,.68,.34,.15,.71,.23,1.12,.23,.36,0,.67-.05,.93-.16,.26-.11,.47-.24,.63-.4,.16-.16,.29-.32,.37-.49h.05v.89h1.24V4.73c0-.48-.08-.87-.25-1.16-.16-.3-.38-.53-.63-.69Zm-.39,3.84c0,.26-.07,.5-.2,.73-.13,.22-.32,.41-.58,.55-.25,.14-.55,.21-.9,.21s-.66-.08-.89-.24c-.23-.16-.35-.4-.35-.72,0-.23,.06-.41,.18-.55,.12-.14,.28-.25,.49-.32,.2-.07,.43-.13,.68-.16,.11-.01,.24-.03,.39-.05,.16-.02,.32-.05,.48-.07,.16-.03,.31-.06,.44-.1,.13-.04,.22-.08,.26-.13v.84Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M21.92,3.59h-.08c-.08-.14-.18-.29-.32-.47-.14-.18-.33-.34-.58-.47-.25-.14-.57-.2-.98-.2-.53,0-1,.13-1.41,.4-.41,.27-.74,.65-.98,1.15-.24,.5-.35,1.11-.35,1.82s.12,1.31,.35,1.82c.24,.5,.56,.89,.97,1.16,.41,.27,.89,.4,1.41,.4,.4,0,.72-.07,.97-.2,.25-.13,.45-.29,.59-.47,.14-.18,.26-.34,.33-.48h.11v1.02h1.24V.35h-1.27V3.59Zm-.18,3.42c-.13,.35-.32,.62-.58,.81-.25,.19-.56,.29-.93,.29s-.7-.1-.95-.3c-.26-.2-.45-.48-.58-.83s-.2-.74-.2-1.18,.06-.82,.19-1.16c.13-.34,.32-.62,.58-.81,.26-.2,.58-.3,.96-.3s.68,.1,.94,.29c.25,.19,.44,.46,.58,.8,.13,.34,.2,.74,.2,1.19s-.07,.86-.2,1.21Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M29.75,3.2c-.28-.26-.59-.45-.93-.58-.35-.12-.7-.18-1.07-.18-.61,0-1.14,.14-1.59,.43-.45,.29-.8,.69-1.06,1.2-.25,.51-.38,1.1-.38,1.77s.12,1.27,.38,1.78c.25,.5,.61,.89,1.07,1.17,.47,.28,1.02,.41,1.67,.41,.48,0,.9-.07,1.27-.22,.38-.15,.69-.35,.93-.62,.25-.27,.42-.58,.52-.93l-1.21-.22c-.08,.2-.19,.38-.33,.52-.14,.14-.32,.24-.52,.32-.2,.07-.42,.1-.66,.1-.37,0-.7-.08-.98-.24-.28-.16-.5-.4-.65-.7-.14-.28-.21-.63-.22-1.03h4.65v-.45c0-.59-.08-1.1-.24-1.51-.16-.42-.38-.76-.65-1.02Zm-3.75,2.03c.02-.28,.08-.55,.2-.79,.14-.28,.35-.51,.61-.68,.27-.18,.58-.26,.94-.26,.33,0,.62,.08,.86,.23,.25,.15,.44,.36,.58,.62,.14,.26,.2,.56,.2,.89h-3.39Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("polygon", {
        fill: "currentColor",
        points: "41.33 7.32 41.27 7.32 39.99 2.53 38.67 2.53 37.39 7.34 37.32 7.34 36.04 2.53 34.72 2.53 36.65 9.08 37.94 9.08 39.27 4.35 39.37 4.35 40.7 9.08 42 9.08 43.92 2.53 42.61 2.53 41.33 7.32"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M45.78,0c-.22,0-.41,.08-.57,.23-.16,.15-.23,.33-.23,.54s.08,.39,.23,.54c.16,.15,.35,.22,.57,.22s.41-.07,.57-.22c.16-.15,.24-.33,.24-.54s-.08-.39-.24-.54c-.16-.15-.35-.23-.57-.23Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("rect", {
        height: "6.55",
        width: "1.27",
        fill: "currentColor",
        x: "45.13",
        y: "2.53"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M50.89,8.01c-.08,.01-.17,.02-.27,.02-.14,0-.27-.02-.39-.06-.12-.05-.21-.13-.29-.25-.07-.12-.11-.31-.11-.56V3.55h1.34v-1.02h-1.34V.96h-1.27v1.57h-.96v1.02h.96v3.87c0,.39,.09,.72,.27,.98,.18,.26,.41,.45,.7,.58,.29,.12,.6,.18,.94,.18,.2,0,.38-.02,.51-.05,.14-.03,.24-.06,.32-.09l-.23-1.05s-.1,.02-.18,.03Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M57.96,3.55c-.18-.37-.45-.64-.78-.83-.34-.18-.73-.28-1.18-.28-.51,0-.92,.1-1.24,.31-.32,.21-.55,.49-.7,.84h-.08V.35h-1.26V9.08h1.27v-3.89c0-.35,.07-.64,.2-.89,.14-.25,.32-.43,.56-.56,.24-.13,.51-.19,.81-.19,.44,0,.78,.13,1.03,.4,.25,.26,.37,.64,.37,1.12v4.01h1.27V4.91c0-.55-.09-1-.28-1.36Z",
        fill: "currentColor"
    })), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M73.18,.27c-1.13,0-2.14,.54-2.75,1.36-.52-.86-1.45-1.36-2.58-1.36-1.05,0-2.02,.49-2.65,1.24l-.44-1.05h-1.67V8.97h2.4V4.37c0-1.32,.64-2.08,1.73-2.08,.86,0,1.31,.6,1.31,1.74v4.95h2.33V4.37c0-1.32,.64-2.08,1.71-2.08,.87,0,1.33,.6,1.33,1.74v4.95h2.4V3.64c0-2-1.29-3.38-3.13-3.38Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M85.47,.46l-.24,.8c-.78-.64-1.78-1.04-2.93-1.04-2.66,0-4.65,1.93-4.65,4.49s1.99,4.51,4.65,4.51c1.13,0,2.12-.38,2.88-1.03l.22,.77h1.87V.46h-1.79Zm-2.98,6.59c-1.4,0-2.42-1.01-2.42-2.33s1.02-2.33,2.42-2.33,2.42,.99,2.42,2.33-1.03,2.33-2.42,2.33Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M97.44,8.97l-3.34-4.45,3.01-4.07h-2.76l-2.66,3.78V.47h-2.4V8.97h2.4V4.9l2.84,4.07h2.92Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M106.76,4.69c0-2.46-1.87-4.47-4.61-4.47s-4.61,1.94-4.61,4.49,1.99,4.51,4.61,4.51c2.07,0,3.76-1.18,4.41-3.04h-2.52c-.36,.61-1.05,.99-1.89,.99-1.17,0-1.95-.65-2.17-1.81h6.72c.04-.22,.05-.44,.05-.67Zm-4.61-2.5c1.09,0,1.86,.57,2.21,1.61h-4.31c.28-1.02,1.04-1.61,2.11-1.61Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M112.67,.41c-1.15,0-1.94,.35-2.58,1.11l-.43-1.05h-1.53V8.98h2.4V4.57c0-1.39,.52-1.97,1.87-1.97h1.05V.41h-.78Z",
        fill: "currentColor"
    })));
}
$d49a83c0facdfaad$var$IconMadeWithMaker.displayName = "IconMadeWithMaker";
var $d49a83c0facdfaad$export$dd44f18ab656f3bb = $d49a83c0facdfaad$var$IconMadeWithMaker;
 /* react Not a pure module */ 
});


parcelRegister("3xYJl", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $29538ff1a1760ace$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $aBI4U = parcelRequire("aBI4U");

var $3T2ER = parcelRequire("3T2ER");

var $agWuE = parcelRequire("agWuE");

var $8dQ4Q = parcelRequire("8dQ4Q");

var $2jMpY = parcelRequire("2jMpY");

var $eNGXn = parcelRequire("eNGXn");

var $gCzsf = parcelRequire("gCzsf");

var $chw5B = parcelRequire("chw5B");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $gf189 = parcelRequire("gf189");
var $29538ff1a1760ace$export$5668677bb0c0ed27 = "#F4F4F5";
function $29538ff1a1760ace$var$ProfileHeader$Logo(Props) {
    var url = Props.url;
    var alt = Props.alt;
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "profile-header-logo",
        children: /*#__PURE__*/ $g85JO.createElement("img", {
            className: $ezf3v.prefix("rounded-full object-cover"),
            style: {
                border: "1px solid " + $29538ff1a1760ace$export$5668677bb0c0ed27 + "",
                height: "96px",
                width: "96px"
            },
            alt: alt,
            src: url
        })
    });
}
$29538ff1a1760ace$var$ProfileHeader$Logo.displayName = "ProfileHeader.Logo";
var $29538ff1a1760ace$export$e6ff31bff12b7ff4 = {
    make: $29538ff1a1760ace$var$ProfileHeader$Logo
};
function $29538ff1a1760ace$export$93fc952515fcc1f7(networks) {
    return $i7mYY.keep(networks, function(network) {
        return network._0.trim() !== "";
    });
}
function $29538ff1a1760ace$export$125d38f00ca93608(link) {
    switch(link.TAG | 0){
        case /* Instagram */ 0:
            return $2jMpY.safeConcat("https://instagram.com/", link._0);
        case /* Tiktok */ 1:
            return $2jMpY.safeConcat("https://tiktok.com/", $2jMpY.safeConcat("@", link._0));
        case /* Twitter */ 2:
            return $2jMpY.safeConcat("https://twitter.com/", link._0);
        case /* Facebook */ 3:
            return $2jMpY.safeConcat("https://facebook.com/", link._0);
        case /* Youtube */ 4:
            return $2jMpY.safeConcat("https://youtube.com/", $2jMpY.safeConcat("@", link._0));
    }
}
function $29538ff1a1760ace$var$ProfileHeader$SocialNetworks(Props) {
    var networks = Props.networks;
    var onClick = Props.onClick;
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "profile-header-social-links",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex items-center justify-center w-full space-x-8")
        }, $29538ff1a1760ace$export$93fc952515fcc1f7(networks).map(function(network, idx) {
            var className = $ezf3v.prefix("text-primary");
            switch(network.TAG | 0){
                case /* Instagram */ 0:
                    return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($chw5B.make, {}),
                        href: $29538ff1a1760ace$export$125d38f00ca93608(network),
                        unstyled: true,
                        className: className,
                        onClick: onClick,
                        key: String(idx)
                    });
                case /* Tiktok */ 1:
                    return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($3T2ER.make, {}),
                        href: $29538ff1a1760ace$export$125d38f00ca93608(network),
                        unstyled: true,
                        className: className,
                        onClick: onClick,
                        key: String(idx)
                    });
                case /* Twitter */ 2:
                    return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($agWuE.make, {}),
                        href: $29538ff1a1760ace$export$125d38f00ca93608(network),
                        unstyled: true,
                        className: className,
                        onClick: onClick,
                        key: String(idx)
                    });
                case /* Facebook */ 3:
                    return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($eNGXn.make, {}),
                        href: $29538ff1a1760ace$export$125d38f00ca93608(network),
                        unstyled: true,
                        className: className,
                        onClick: onClick,
                        key: String(idx)
                    });
                case /* Youtube */ 4:
                    return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($8dQ4Q.make, {}),
                        href: $29538ff1a1760ace$export$125d38f00ca93608(network),
                        unstyled: true,
                        className: className,
                        onClick: onClick,
                        key: String(idx)
                    });
            }
        }))
    });
}
$29538ff1a1760ace$var$ProfileHeader$SocialNetworks.displayName = "ProfileHeader.SocialNetworks";
var $29538ff1a1760ace$export$62c78d3ce1051ca4 = {
    make: $29538ff1a1760ace$var$ProfileHeader$SocialNetworks
};
function $29538ff1a1760ace$var$ProfileHeader(Props) {
    var config = Props.config;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var onSocialNetworkLinkClicked = function onSocialNetworkLinkClicked(param) {
        $iv6Yc.app(trackEvent, [
            "mkrbio:link_clicked",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var onCTAClicked = function onCTAClicked(param) {
        $iv6Yc.app(trackEvent, [
            "mkrbio:cta_clicked",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var callToAction = config.callToAction;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative bg-main")
    }, /*#__PURE__*/ $g85JO.createElement($aBI4U.make, {}), /*#__PURE__*/ $g85JO.createElement($gf189.make, {
        className: $ezf3v.prefix("relative flex justify-end mr-4")
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex flex-col items-center mx-auto text-center"),
        style: {
            maxWidth: "430px",
            padding: "24px 16px 20px"
        }
    }, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: config.logoUrl !== "",
        children: /*#__PURE__*/ $g85JO.createElement($29538ff1a1760ace$var$ProfileHeader$Logo, {
            url: config.logoUrl,
            alt: "Profile logo"
        })
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: config.name !== undefined,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "profile-header-name",
            children: /*#__PURE__*/ $g85JO.createElement("p", {
                className: $ezf3v.prefix("mt-4 font-semibold text-3xl text-primary")
            }, $2whNH.getWithDefault(config.name, ""))
        })
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: config.description !== undefined,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "profile-header-description",
            children: /*#__PURE__*/ $g85JO.createElement("p", {
                className: $ezf3v.prefix("mt-4 text-secondary"),
                style: {
                    fontSize: "14px",
                    fontWeight: "300"
                }
            }, $2whNH.getWithDefault(config.description, ""))
        })
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: config.socialNetworksLinks.length > 0,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            style: {
                marginTop: "16px"
            }
        }, /*#__PURE__*/ $g85JO.createElement($29538ff1a1760ace$var$ProfileHeader$SocialNetworks, {
            networks: config.socialNetworksLinks,
            onClick: onSocialNetworkLinkClicked
        }))
    }), callToAction !== undefined ? /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
        children: callToAction.label,
        href: callToAction.url,
        unstyled: true,
        className: $ezf3v.prefix($1TRFX.make([
            "border-solid border-2 border-primary text-primary",
            "w-full",
            "bg-main",
            "flex items-center justify-center ",
            "text-lg font-semibold drop-shadow-sm cursor-pointer",
            "font-semibold",
            "shadow-hard-edge hover:shadow-hard-edge-lg"
        ])),
        style: {
            fontSize: "14px",
            height: "44px",
            lineHeight: "14px",
            marginTop: "16px",
            textDecoration: "none"
        },
        dataTestId: "profile-header-cta-button",
        onClick: onCTAClicked
    }) : null));
}
$29538ff1a1760ace$var$ProfileHeader.displayName = "ProfileHeader";
var $29538ff1a1760ace$export$dd44f18ab656f3bb = $29538ff1a1760ace$var$ProfileHeader;
var $29538ff1a1760ace$export$aa541d093b11ace2 = $29538ff1a1760ace$var$ProfileHeader;
 /* react Not a pure module */ 
});
parcelRegister("aBI4U", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $7b8f8d147ba2cf67$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $c6E1z = parcelRequire("c6E1z");

var $76L9c = parcelRequire("76L9c");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $kJhYp = parcelRequire("kJhYp");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
var $7b8f8d147ba2cf67$export$c27a244ab8251106 = {};
function $7b8f8d147ba2cf67$var$MetaTags$1(Props) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var route = match$1.route;
    var match$2 = $efwy1.use(undefined);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, config.categories);
    var match$3 = $9pMGg.use(undefined);
    var productId;
    if (typeof route === "number") productId = undefined;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            productId = route._0.productId;
            break;
        case /* QuickView */ 3:
            productId = route._0.productId;
            break;
        default:
            productId = undefined;
    }
    var match$4 = $c6E1z.useProductById(false, $2whNH.map(activeCategory, function(cat) {
        return cat.id;
    }), match$3.smartnavApiHost, match$3.market, $2whNH.getWithDefault(productId, ""));
    var product = match$4.product;
    var bio = config.settings.mkrBio;
    if (bio === undefined) return null;
    var name = bio.name;
    var prefix = name !== undefined ? name + "'s " : "";
    var title;
    if (typeof route === "number") title = "Instagram Posts";
    else switch(route.TAG | 0){
        case /* Home */ 0:
            title = "Instagram Posts";
            break;
        case /* ListPage */ 1:
            if (activeCategory !== undefined && activeCategory.title !== "Instagram") {
                var match$5 = activeCategory.socialNetworkSource;
                title = match$5 !== undefined ? match$5.TAG === /* Instagram */ 0 ? "Instagram Posts" : "Tiktok Videos" : activeCategory.title;
            } else title = "Instagram Posts";
            break;
        case /* PDP */ 2:
        case /* QuickView */ 3:
            title = product !== undefined ? product.name : "Instagram Posts";
            break;
    }
    var title$1 = prefix + title + " in Mkr Bio";
    var image;
    if (typeof route === "number") image = bio.logoUrl;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            image = product !== undefined ? $i7mYY.get($7KlbQ.getValidProductImages(product), 0) : bio.logoUrl;
            break;
        case /* QuickView */ 3:
            image = product !== undefined ? $i7mYY.get($7KlbQ.getValidProductImages(product), 0) : $2whNH.map($1xf0g.getCategoryById(config.categories, route._0.mediaId), $1xf0g.getCategoryImage);
            break;
        default:
            image = bio.logoUrl;
    }
    var video;
    var exit = 0;
    var product$1;
    if (typeof route === "number") video = undefined;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            if (product !== undefined) {
                product$1 = product;
                exit = 1;
            } else video = undefined;
            break;
        case /* QuickView */ 3:
            if (product !== undefined) {
                product$1 = product;
                exit = 1;
            } else video = $2whNH.flatMap($1xf0g.getCategoryById(config.categories, route._0.mediaId), $1xf0g.getCategoryVideo);
            break;
        default:
            video = undefined;
    }
    if (exit === 1) video = $2whNH.flatMap($i7mYY.get(product$1.allMedia, 0), $7KlbQ.Media.getVideoUrl);
    var description;
    if (typeof route === "number") description = bio.description;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
        case /* QuickView */ 3:
            description = product !== undefined ? product.description : bio.description;
            break;
        default:
            description = bio.description;
    }
    return /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($76L9c))), {
        children: null
    }, /*#__PURE__*/ $g85JO.createElement("title", undefined, title$1), /*#__PURE__*/ $g85JO.createElement("meta", {
        content: title$1,
        property: "og:title"
    }), /*#__PURE__*/ $g85JO.createElement("meta", {
        content: "website",
        property: "og:type"
    }), /*#__PURE__*/ $g85JO.createElement("meta", {
        content: prefix + "Mkr Bio",
        property: "og:site_name"
    }), /*#__PURE__*/ $g85JO.createElement("meta", {
        content: $kJhYp.getCurrentPermalink(match$2.namespace, undefined),
        property: "og:url"
    }), $2whNH.mapWithDefault(image, null, function(image) {
        return /*#__PURE__*/ $g85JO.createElement("meta", {
            content: image,
            property: "og:image"
        });
    }), $2whNH.mapWithDefault(video, null, function(video) {
        return /*#__PURE__*/ $g85JO.createElement("meta", {
            content: video,
            property: "og:video"
        });
    }), $2whNH.mapWithDefault(description, null, function(description) {
        return /*#__PURE__*/ $g85JO.createElement("meta", {
            content: description,
            property: "og:description"
        });
    }));
}
$7b8f8d147ba2cf67$var$MetaTags$1.displayName = "MetaTags.1";
var $7b8f8d147ba2cf67$export$dd44f18ab656f3bb = $7b8f8d147ba2cf67$var$MetaTags$1;
 /* react Not a pure module */ 
});
parcelRegister("76L9c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MetaTagsContext", {
    enumerable: true,
    get: function get() {
        return $52cdaa7346adb86a$var$_meta_tags_context.default;
    }
});
Object.defineProperty(module.exports, "MetaTags", {
    enumerable: true,
    get: function get() {
        return $52cdaa7346adb86a$var$_meta_tags.default;
    }
});
Object.defineProperty(module.exports, "ReactTitle", {
    enumerable: true,
    get: function get() {
        return $52cdaa7346adb86a$var$_react_title.default;
    }
});
module.exports.default = void 0;

var $52cdaa7346adb86a$var$_meta_tags_context = $52cdaa7346adb86a$var$_interopRequireDefault((parcelRequire("g2M0p")));

var $52cdaa7346adb86a$var$_meta_tags = $52cdaa7346adb86a$var$_interopRequireDefault((parcelRequire("PDVtP")));

var $52cdaa7346adb86a$var$_react_title = $52cdaa7346adb86a$var$_interopRequireDefault((parcelRequire("gYVNg")));
function $52cdaa7346adb86a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $52cdaa7346adb86a$var$_default = $52cdaa7346adb86a$var$_meta_tags.default;
module.exports.default = $52cdaa7346adb86a$var$_default;

});
parcelRegister("g2M0p", function(module, exports) {

var $gfRPo = parcelRequire("gfRPo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.MetaContext = void 0;

var $bae2122a445d1614$var$_react = $bae2122a445d1614$var$_interopRequireWildcard((parcelRequire("g85JO")));
function $bae2122a445d1614$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $bae2122a445d1614$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $gfRPo._)(Symbol.iterator) === "symbol") $bae2122a445d1614$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $gfRPo._)(obj);
    };
    else $bae2122a445d1614$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $gfRPo._)(obj);
    };
    return $bae2122a445d1614$var$_typeof(obj);
}
function $bae2122a445d1614$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bae2122a445d1614$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bae2122a445d1614$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bae2122a445d1614$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bae2122a445d1614$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bae2122a445d1614$var$_possibleConstructorReturn(self, call) {
    if (call && ($bae2122a445d1614$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bae2122a445d1614$var$_assertThisInitialized(self);
}
function $bae2122a445d1614$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bae2122a445d1614$var$_getPrototypeOf(o) {
    $bae2122a445d1614$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bae2122a445d1614$var$_getPrototypeOf(o);
}
function $bae2122a445d1614$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bae2122a445d1614$var$_setPrototypeOf(subClass, superClass);
}
function $bae2122a445d1614$var$_setPrototypeOf(o, p) {
    $bae2122a445d1614$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bae2122a445d1614$var$_setPrototypeOf(o, p);
}
var $bae2122a445d1614$var$MetaContext = (0, $bae2122a445d1614$var$_react.createContext)({});
/** context class which passes extract fuunction to MetaTags Component **/ module.exports.MetaContext = $bae2122a445d1614$var$MetaContext;
var $bae2122a445d1614$var$MetaContextProviderWrapper = /*#__PURE__*/ function(_Component) {
    $bae2122a445d1614$var$_inherits(MetaContextProviderWrapper, _Component);
    function MetaContextProviderWrapper() {
        $bae2122a445d1614$var$_classCallCheck(this, MetaContextProviderWrapper);
        return $bae2122a445d1614$var$_possibleConstructorReturn(this, $bae2122a445d1614$var$_getPrototypeOf(MetaContextProviderWrapper).apply(this, arguments));
    }
    $bae2122a445d1614$var$_createClass(MetaContextProviderWrapper, [
        {
            key: "render",
            value: function render() {
                return $bae2122a445d1614$var$_react.default.createElement($bae2122a445d1614$var$MetaContext.Provider, {
                    value: {
                        extract: this.props.extract
                    }
                }, $bae2122a445d1614$var$_react.Children.only(this.props.children));
            }
        }
    ]);
    return MetaContextProviderWrapper;
}($bae2122a445d1614$var$_react.Component);
var $bae2122a445d1614$var$_default = $bae2122a445d1614$var$MetaContextProviderWrapper;
module.exports.default = $bae2122a445d1614$var$_default;

});

parcelRegister("PDVtP", function(module, exports) {

var $gfRPo = parcelRequire("gfRPo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09b3bc06b209ea88$var$_react = $09b3bc06b209ea88$var$_interopRequireWildcard((parcelRequire("g85JO")));

var $09b3bc06b209ea88$var$_reactDom = $09b3bc06b209ea88$var$_interopRequireDefault((parcelRequire("6fLEz")));

var $lIGBk = parcelRequire("lIGBk");

var $g2M0p = parcelRequire("g2M0p");
function $09b3bc06b209ea88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $09b3bc06b209ea88$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $09b3bc06b209ea88$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $gfRPo._)(Symbol.iterator) === "symbol") $09b3bc06b209ea88$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $gfRPo._)(obj);
    };
    else $09b3bc06b209ea88$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $gfRPo._)(obj);
    };
    return $09b3bc06b209ea88$var$_typeof(obj);
}
function $09b3bc06b209ea88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $09b3bc06b209ea88$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $09b3bc06b209ea88$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $09b3bc06b209ea88$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $09b3bc06b209ea88$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $09b3bc06b209ea88$var$_possibleConstructorReturn(self, call) {
    if (call && ($09b3bc06b209ea88$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $09b3bc06b209ea88$var$_assertThisInitialized(self);
}
function $09b3bc06b209ea88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $09b3bc06b209ea88$var$_getPrototypeOf(o) {
    $09b3bc06b209ea88$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $09b3bc06b209ea88$var$_getPrototypeOf(o);
}
function $09b3bc06b209ea88$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $09b3bc06b209ea88$var$_setPrototypeOf(subClass, superClass);
}
function $09b3bc06b209ea88$var$_setPrototypeOf(o, p) {
    $09b3bc06b209ea88$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $09b3bc06b209ea88$var$_setPrototypeOf(o, p);
}
function $09b3bc06b209ea88$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** An wrapper component to wrap element which need to shifted to head **/ var $09b3bc06b209ea88$var$MetaTags = /*#__PURE__*/ function(_Component) {
    $09b3bc06b209ea88$var$_inherits(MetaTags, _Component);
    function MetaTags() {
        $09b3bc06b209ea88$var$_classCallCheck(this, MetaTags);
        return $09b3bc06b209ea88$var$_possibleConstructorReturn(this, $09b3bc06b209ea88$var$_getPrototypeOf(MetaTags).apply(this, arguments));
    }
    $09b3bc06b209ea88$var$_createClass(MetaTags, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.temporaryElement = document.createElement("div");
                this.handleChildrens();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(oldProps) {
                if (oldProps.children !== this.props.children) this.handleChildrens();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.temporaryElement) $09b3bc06b209ea88$var$_reactDom.default.unmountComponentAtNode(this.temporaryElement);
            }
        },
        {
            key: "extractChildren",
            value: function extractChildren() {
                var extract = this.context.extract;
                var children = this.props.children;
                if (!children) return;
                if (extract) extract(children);
            }
        },
        {
            key: "handleChildrens",
            value: function handleChildrens() {
                var _this = this;
                var children = this.props.children;
                if (this.context.extract || !children) return;
                var headComponent = $09b3bc06b209ea88$var$_react.default.createElement("div", {
                    className: "react-head-temp"
                }, children);
                $09b3bc06b209ea88$var$_reactDom.default.render(headComponent, this.temporaryElement, function() {
                    var childStr = _this.temporaryElement.innerHTML; //if html is not changed return
                    if (_this.lastChildStr === childStr) return;
                    _this.lastChildStr = childStr;
                    var tempHead = _this.temporaryElement.querySelector(".react-head-temp"); // .react-head-temp might not exist when triggered from async action
                    if (tempHead === null) return;
                    var childNodes = Array.prototype.slice.call(tempHead.children);
                    var head = document.head;
                    var headHtml = head.innerHTML; //filter children remove if children has not been changed
                    childNodes = childNodes.filter(function(child) {
                        return headHtml.indexOf(child.outerHTML) === -1;
                    }); //create clone of childNodes
                    childNodes = childNodes.map(function(child) {
                        return child.cloneNode(true);
                    }); //remove duplicate title and meta from head
                    childNodes.forEach(function(child) {
                        var tag = child.tagName.toLowerCase();
                        if (tag === "title") {
                            var title = (0, $lIGBk.getDuplicateTitle)();
                            if (title) (0, $lIGBk.removeChild)(head, title);
                        } else if (child.id) {
                            // if the element has id defined remove the existing element with that id
                            var elm = (0, $lIGBk.getDuplicateElementById)(child);
                            if (elm) (0, $lIGBk.removeChild)(head, elm);
                        } else if (tag === "meta") {
                            var meta = (0, $lIGBk.getDuplicateMeta)(child);
                            if (meta) (0, $lIGBk.removeChild)(head, meta);
                        } else if (tag === "link" && child.rel === "canonical") {
                            var link = (0, $lIGBk.getDuplicateCanonical)(child);
                            if (link) (0, $lIGBk.removeChild)(head, link);
                        }
                    });
                    (0, $lIGBk.appendChild)(document.head, childNodes);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                this.extractChildren();
                return null;
            }
        }
    ]);
    return MetaTags;
}($09b3bc06b209ea88$var$_react.Component);
$09b3bc06b209ea88$var$_defineProperty($09b3bc06b209ea88$var$MetaTags, "contextType", $g2M0p.MetaContext);
var $09b3bc06b209ea88$var$_default = $09b3bc06b209ea88$var$MetaTags;
module.exports.default = $09b3bc06b209ea88$var$_default;
module.exports = module.exports.default;

});
parcelRegister("lIGBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filterAndArrangeTags = $fcfec0b8c33b0343$var$filterAndArrangeTags;
module.exports.getDuplicateTitle = $fcfec0b8c33b0343$var$getDuplicateTitle;
module.exports.getDuplicateCanonical = $fcfec0b8c33b0343$var$getDuplicateCanonical;
module.exports.getDuplicateElementById = $fcfec0b8c33b0343$var$getDuplicateElementById;
module.exports.getDuplicateMeta = $fcfec0b8c33b0343$var$getDuplicateMeta;
module.exports.appendChild = $fcfec0b8c33b0343$var$appendChild;
module.exports.removeChild = $fcfec0b8c33b0343$var$removeChild;
function $fcfec0b8c33b0343$var$_toConsumableArray(arr) {
    return $fcfec0b8c33b0343$var$_arrayWithoutHoles(arr) || $fcfec0b8c33b0343$var$_iterableToArray(arr) || $fcfec0b8c33b0343$var$_nonIterableSpread();
}
function $fcfec0b8c33b0343$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $fcfec0b8c33b0343$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $fcfec0b8c33b0343$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var $fcfec0b8c33b0343$var$camelCaseProps = [
    "itemProp"
];
var $fcfec0b8c33b0343$var$uniqueIdentifiersI = [
    "property",
    "name",
    "itemprop"
];
var $fcfec0b8c33b0343$var$uniqueIdentifiers = $fcfec0b8c33b0343$var$uniqueIdentifiersI.concat($fcfec0b8c33b0343$var$camelCaseProps); //case sensitive props is defined in case anyone defined the lowercase prop
var $fcfec0b8c33b0343$var$uniqueIdentifiersAll = $fcfec0b8c33b0343$var$uniqueIdentifiers.concat([
    "id"
]);
/**
  Note:
  1. In server side we will add meta tags and title at last after fitering
  2. In client we will match and replace meta tagString
  3. For now we will not support link and other tags properly, they can be added but we will not check for uniqueness and will not decide placement
**/ function $fcfec0b8c33b0343$var$filterOutMetaWithId(metas) {
    metas = Array.prototype.slice.call(metas || []);
    return metas.filter(function(meta) {
        return !meta.id;
    });
}
function $fcfec0b8c33b0343$var$filterAndArrangeTags(headElms) {
    var title = null;
    var canonicalLink = null;
    var metas = [];
    var rest = [];
    headElms.forEach(function(elm) {
        var type = elm.type, props = elm.props;
        if (type === "title") title = elm;
        else if (type === "link" && props.rel === "canonical") canonicalLink = elm;
        else if (type === "meta") metas.push(elm);
        else rest.push(elm);
    });
    return [
        title
    ].concat($fcfec0b8c33b0343$var$_toConsumableArray($fcfec0b8c33b0343$var$removeDuplicateMetas(metas)), [
        canonicalLink
    ], rest);
}
function $fcfec0b8c33b0343$var$removeDuplicateMetas(metas) {
    var addedMeta = {}; //initialize all the identifiers with empty array
    $fcfec0b8c33b0343$var$uniqueIdentifiersAll.forEach(function(identifier) {
        addedMeta[identifier] = [];
    });
    var filteredMetas = [];
    var _loop = function _loop(i) {
        var meta = metas[i];
        var id = meta.props.id;
        var addMeta = false; //if has id and element with id is not present than always add meta
        if (id) addMeta = !addedMeta.id[id]; //for any other unique identifier check if meta already available with same identifier which doesn't have id
        else addMeta = $fcfec0b8c33b0343$var$uniqueIdentifiers.filter(function(identifier) {
            var identifierValue = meta.props[identifier];
            var existing = addedMeta[identifier][identifierValue];
            return existing && !existing.props.id;
        }).length === 0;
        if (addMeta) {
            filteredMetas.unshift(meta); //add meta as added
            $fcfec0b8c33b0343$var$uniqueIdentifiersAll.forEach(function(identifier) {
                var identifierValue = meta.props[identifier];
                if (identifierValue) addedMeta[identifier][identifierValue] = meta;
            });
        }
    };
    for(var i = metas.length - 1; i >= 0; i--)_loop(i);
    return filteredMetas;
}
function $fcfec0b8c33b0343$var$getDuplicateTitle() {
    return document.head.querySelectorAll("title");
}
function $fcfec0b8c33b0343$var$getDuplicateCanonical() {
    return document.head.querySelectorAll('link[rel="canonical"]');
}
function $fcfec0b8c33b0343$var$getDuplicateElementById(_ref) {
    var id = _ref.id;
    return id && document.head.querySelector("#".concat(id));
}
function $fcfec0b8c33b0343$var$getDuplicateMeta(meta) {
    var head = document.head; //for any other unique identifier check if metas already available with same identifier which doesn't have id
    return $fcfec0b8c33b0343$var$uniqueIdentifiersI.reduce(function(duplicates, identifier) {
        var identifierValue = meta.getAttribute(identifier);
        return identifierValue ? duplicates.concat($fcfec0b8c33b0343$var$filterOutMetaWithId(head.querySelectorAll("[".concat(identifier, ' = "').concat(identifierValue, '"]')))) : duplicates;
    }, []);
} //function to append childrens on a parent
function $fcfec0b8c33b0343$var$appendChild(parent, childrens) {
    if (childrens.length === undefined) childrens = [
        childrens
    ];
    var docFrag = document.createDocumentFragment(); //we used for loop instead of forEach because childrens can be array like object
    for(var i = 0, ln = childrens.length; i < ln; i++)docFrag.appendChild(childrens[i]);
    parent.appendChild(docFrag);
}
function $fcfec0b8c33b0343$var$removeChild(parent, childrens) {
    if (childrens.length === undefined) childrens = [
        childrens
    ];
    for(var i = 0, ln = childrens.length; i < ln; i++)parent.removeChild(childrens[i]);
}

});


parcelRegister("gYVNg", function(module, exports) {

var $gfRPo = parcelRequire("gfRPo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c5cf1484ab0e9cb6$var$_react = $c5cf1484ab0e9cb6$var$_interopRequireWildcard((parcelRequire("g85JO")));

var $c5cf1484ab0e9cb6$var$_meta_tags = $c5cf1484ab0e9cb6$var$_interopRequireDefault((parcelRequire("PDVtP")));
function $c5cf1484ab0e9cb6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c5cf1484ab0e9cb6$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $c5cf1484ab0e9cb6$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $gfRPo._)(Symbol.iterator) === "symbol") $c5cf1484ab0e9cb6$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $gfRPo._)(obj);
    };
    else $c5cf1484ab0e9cb6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $gfRPo._)(obj);
    };
    return $c5cf1484ab0e9cb6$var$_typeof(obj);
}
function $c5cf1484ab0e9cb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c5cf1484ab0e9cb6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c5cf1484ab0e9cb6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c5cf1484ab0e9cb6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c5cf1484ab0e9cb6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c5cf1484ab0e9cb6$var$_possibleConstructorReturn(self, call) {
    if (call && ($c5cf1484ab0e9cb6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c5cf1484ab0e9cb6$var$_assertThisInitialized(self);
}
function $c5cf1484ab0e9cb6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c5cf1484ab0e9cb6$var$_getPrototypeOf(o) {
    $c5cf1484ab0e9cb6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c5cf1484ab0e9cb6$var$_getPrototypeOf(o);
}
function $c5cf1484ab0e9cb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c5cf1484ab0e9cb6$var$_setPrototypeOf(subClass, superClass);
}
function $c5cf1484ab0e9cb6$var$_setPrototypeOf(o, p) {
    $c5cf1484ab0e9cb6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c5cf1484ab0e9cb6$var$_setPrototypeOf(o, p);
}
var $c5cf1484ab0e9cb6$var$ReactTitle = /*#__PURE__*/ function(_Component) {
    $c5cf1484ab0e9cb6$var$_inherits(ReactTitle, _Component);
    function ReactTitle() {
        $c5cf1484ab0e9cb6$var$_classCallCheck(this, ReactTitle);
        return $c5cf1484ab0e9cb6$var$_possibleConstructorReturn(this, $c5cf1484ab0e9cb6$var$_getPrototypeOf(ReactTitle).apply(this, arguments));
    }
    $c5cf1484ab0e9cb6$var$_createClass(ReactTitle, [
        {
            key: "render",
            value: function render() {
                return $c5cf1484ab0e9cb6$var$_react.default.createElement($c5cf1484ab0e9cb6$var$_meta_tags.default, null, $c5cf1484ab0e9cb6$var$_react.default.createElement("title", null, this.props.title));
            }
        }
    ]);
    return ReactTitle;
}($c5cf1484ab0e9cb6$var$_react.Component);
var $c5cf1484ab0e9cb6$var$_default = $c5cf1484ab0e9cb6$var$ReactTitle;
module.exports.default = $c5cf1484ab0e9cb6$var$_default;
module.exports = module.exports.default;

});



parcelRegister("agWuE", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $77a8c58ede2c35e1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $77a8c58ede2c35e1$var$IconTwitter(Props) {
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        height: "22",
        width: "26",
        fill: "none",
        viewBox: "0 0 26 22",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M16.1212 4.3414C13.8337 4.3414 11.9843 6.16764 11.9843 8.3908C11.9843 8.6037 11.899 8.80773 11.7474 8.95725L11.7445 8.96015C11.5432 9.15868 11.2518 9.23552 10.9788 9.16203C9.33002 8.71809 7.51276 7.62716 5.19461 5.13886C4.08456 7.56678 4.33299 9.83187 4.91827 11.5802C5.25119 12.5746 5.69221 13.3953 6.05037 13.967C6.22894 14.252 6.38548 14.4728 6.49527 14.6199C6.55012 14.6934 6.59317 14.7483 6.62128 14.7834C6.63534 14.8009 6.64565 14.8135 6.65182 14.821L6.65752 14.8278L6.65793 14.8283L6.65794 14.8283C6.83213 15.0329 6.89134 15.3115 6.81536 15.5692C6.73931 15.8272 6.53813 16.0292 6.28054 16.1064L4.31457 16.6956C6.03322 18.5474 8.32853 19.6586 10.8263 19.6586C16.0035 19.6586 20.3754 14.8266 20.3754 8.63551C20.3754 8.49061 20.415 8.34846 20.4898 8.2244L21.6543 6.2947L20.0601 6.29623C19.7883 6.2965 19.5391 6.15849 19.3938 5.9367C18.6428 4.96739 17.4581 4.3414 16.1212 4.3414ZM20.4398 4.70447C19.3934 3.50663 17.8453 2.75 16.1212 2.75C13.3559 2.75 11.0141 4.70034 10.4984 7.30812C9.24436 6.75516 7.69299 5.61878 5.62627 3.23835C5.45937 3.04611 5.21056 2.94534 4.95693 2.96726C4.70329 2.98918 4.47546 3.13114 4.34401 3.34916C2.35916 6.6412 2.64159 9.79246 3.40919 12.0854C3.79131 13.2268 4.29449 14.1618 4.70178 14.8119C4.72082 14.8423 4.73968 14.8721 4.75831 14.9013L2.70695 15.516C2.45848 15.5904 2.26189 15.7813 2.18017 16.0275C2.09846 16.2737 2.14186 16.5443 2.29649 16.7525C4.3215 19.48 7.37815 21.25 10.8263 21.25C17.0067 21.25 21.8599 15.6247 21.9651 8.85988L23.7459 5.90875C23.8943 5.66288 23.8987 5.35614 23.7574 5.10614C23.6161 4.85614 23.351 4.70166 23.0639 4.70194L20.4398 4.70447Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
}
$77a8c58ede2c35e1$var$IconTwitter.displayName = "IconTwitter";
var $77a8c58ede2c35e1$export$dd44f18ab656f3bb = $77a8c58ede2c35e1$var$IconTwitter;
 /* react Not a pure module */ 
});

parcelRegister("8dQ4Q", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5fc7ef0d7ff92a44$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $5fc7ef0d7ff92a44$var$IconYoutube(Props) {
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        height: "22",
        width: "26",
        fill: "none",
        viewBox: "0 0 26 22",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M2.35985 6.32869C2.2732 7.02325 2.27188 7.86642 2.27188 8.93803V13.0624C2.27188 15.0755 2.50306 16.2744 3.14684 17.0102C3.76698 17.719 4.96213 18.2002 7.49614 18.2002H18.5047C20.8464 18.2002 22.0456 17.8994 22.7153 17.2582C23.3748 16.6268 23.729 15.4598 23.729 13.0624V8.93803C23.729 7.81959 23.7134 6.95011 23.6112 6.25166C23.51 5.56038 23.3347 5.1228 23.0782 4.81794C22.8283 4.52082 22.427 4.26211 21.6969 4.07919C20.955 3.89334 19.9307 3.8002 18.5047 3.8002H7.49614C6.01675 3.8002 4.96817 3.90689 4.22036 4.10721C3.48585 4.30396 3.09308 4.57678 2.85358 4.88111C2.60532 5.19658 2.44556 5.64168 2.35985 6.32869ZM3.80636 2.5617C4.75289 2.30815 5.9634 2.2002 7.49614 2.2002H18.5047C19.9769 2.2002 21.1546 2.2939 22.0857 2.52715C23.0285 2.76334 23.771 3.15601 24.3026 3.78796C24.8277 4.41217 25.0716 5.18136 25.1944 6.01996C25.316 6.8514 25.329 7.83492 25.329 8.93803V13.0624C25.329 15.4778 25.0066 17.2797 23.8218 18.414C22.6472 19.5385 20.8343 19.8002 18.5047 19.8002H7.49614C4.85881 19.8002 3.04182 19.3201 1.94267 18.0638C0.867149 16.8345 0.671876 15.0644 0.671876 13.0624L0.671875 8.89843C0.671859 7.87505 0.671844 6.93472 0.772159 6.13061C0.87471 5.30859 1.09147 4.53303 1.59624 3.89162C2.10978 3.23907 2.84655 2.8188 3.80636 2.5617ZM10.2287 6.97786C10.4675 6.83276 10.7647 6.82277 11.0127 6.95148L17.2282 10.1776C17.493 10.315 17.6593 10.5882 17.6597 10.8865C17.6601 11.1847 17.4946 11.4584 17.2303 11.5966L11.0148 14.8453C10.7668 14.975 10.4691 14.9656 10.2297 14.8206C9.99038 14.6757 9.84417 14.4162 9.84417 14.1363V7.66154C9.84417 7.38212 9.98995 7.12296 10.2287 6.97786ZM11.4442 8.97811V12.8155L15.1279 10.8901L11.4442 8.97811Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
}
$5fc7ef0d7ff92a44$var$IconYoutube.displayName = "IconYoutube";
var $5fc7ef0d7ff92a44$export$dd44f18ab656f3bb = $5fc7ef0d7ff92a44$var$IconYoutube;
 /* react Not a pure module */ 
});

parcelRegister("eNGXn", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $ac66f69c54f9a7d1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $ac66f69c54f9a7d1$var$IconFacebook(Props) {
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        height: "23",
        width: "27",
        fill: "none",
        viewBox: "0 0 27 23",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M11.5 10.129C11.5 8.20749 13.0579 6.64775 14.9813 6.64775H16.629C17.0708 6.64775 17.429 7.00593 17.429 7.44775C17.429 7.88958 17.0708 8.24775 16.629 8.24775H14.9813C13.942 8.24775 13.1 9.09062 13.1 10.129V20.7358C13.1 21.1777 12.7418 21.5358 12.3 21.5358C11.8582 21.5358 11.5 21.1777 11.5 20.7358V10.129Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M8.7 12.1826C8.7 11.7408 9.05817 11.3826 9.5 11.3826H16.2641C16.7059 11.3826 17.0641 11.7408 17.0641 12.1826C17.0641 12.6244 16.7059 12.9826 16.2641 12.9826H9.5C9.05817 12.9826 8.7 12.6244 8.7 12.1826Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M13.0664 20.6358C17.9817 20.6358 21.9664 16.6512 21.9664 11.7358C21.9664 6.82051 17.9817 2.83584 13.0664 2.83584C8.15107 2.83584 4.16641 6.82051 4.16641 11.7358C4.16641 16.6512 8.15107 20.6358 13.0664 20.6358ZM13.0664 22.2358C18.8654 22.2358 23.5664 17.5348 23.5664 11.7358C23.5664 5.93685 18.8654 1.23584 13.0664 1.23584C7.26742 1.23584 2.56641 5.93685 2.56641 11.7358C2.56641 17.5348 7.26742 22.2358 13.0664 22.2358Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
}
$ac66f69c54f9a7d1$var$IconFacebook.displayName = "IconFacebook";
var $ac66f69c54f9a7d1$export$dd44f18ab656f3bb = $ac66f69c54f9a7d1$var$IconFacebook;
 /* react Not a pure module */ 
});

parcelRegister("chw5B", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $8f0ff6d8961bbba9$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $8f0ff6d8961bbba9$var$IconInstagram(Props) {
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        height: "22",
        width: "26",
        fill: "none",
        viewBox: "0 0 26 22",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M8.66336 3.3002C6.84438 3.3002 5.3002 4.86533 5.3002 6.88413V15.1163C5.3002 17.1351 6.84438 18.7002 8.66336 18.7002H17.337C19.156 18.7002 20.7002 17.1351 20.7002 15.1163V6.88413C20.7002 4.86533 19.156 3.3002 17.337 3.3002H8.66336ZM3.7002 6.88413C3.7002 4.06058 5.88383 1.7002 8.66336 1.7002H17.337C20.1166 1.7002 22.3002 4.06058 22.3002 6.88413V15.1163C22.3002 17.9398 20.1166 20.3002 17.337 20.3002H8.66336C5.88383 20.3002 3.7002 17.9398 3.7002 15.1163V6.88413Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        clipRule: "evenodd",
        d: "M13.0002 8.3002C11.509 8.3002 10.3002 9.50903 10.3002 11.0002C10.3002 12.4914 11.509 13.7002 13.0002 13.7002C14.4914 13.7002 15.7002 12.4914 15.7002 11.0002C15.7002 9.50903 14.4914 8.3002 13.0002 8.3002ZM8.7002 11.0002C8.7002 8.62537 10.6254 6.7002 13.0002 6.7002C15.375 6.7002 17.3002 8.62537 17.3002 11.0002C17.3002 13.375 15.375 15.3002 13.0002 15.3002C10.6254 15.3002 8.7002 13.375 8.7002 11.0002Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M17.8434 7.35845C18.4506 7.35845 18.9429 6.86596 18.9429 6.25845C18.9429 5.65093 18.4506 5.15845 17.8434 5.15845C17.2362 5.15845 16.7439 5.65093 16.7439 6.25845C16.7439 6.86596 17.2362 7.35845 17.8434 7.35845Z",
        fill: "currentColor"
    }));
}
$8f0ff6d8961bbba9$var$IconInstagram.displayName = "IconInstagram";
var $8f0ff6d8961bbba9$export$dd44f18ab656f3bb = $8f0ff6d8961bbba9$var$IconInstagram;
 /* react Not a pure module */ 
});

parcelRegister("gf189", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $bd2eec8fe37aebcf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $bd2eec8fe37aebcf$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("lXydE"));
});
function $bd2eec8fe37aebcf$var$MarketsDropdown_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($bd2eec8fe37aebcf$var$component, Props);
}
$bd2eec8fe37aebcf$var$MarketsDropdown_Lazy.displayName = "MarketsDropdown_Lazy";
var $bd2eec8fe37aebcf$export$dd44f18ab656f3bb = $bd2eec8fe37aebcf$var$MarketsDropdown_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("lXydE", function(module, exports) {


module.exports = (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("lihB3")).then(function() {
    return parcelRequire("kUAVB");
});

});



parcelRegister("lBn5n", function(module, exports) {

$parcel$export(module.exports, "useContextualRoot", function () { return $fb9ef608eb76e9b2$export$fd42e504a4d8f825; });
$parcel$export(module.exports, "useContextualL1s", function () { return $fb9ef608eb76e9b2$export$f20aa461418ac738; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $bygWp = parcelRequire("bygWp");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $fb9ef608eb76e9b2$export$b829272b1dcc6798(url) {
    try {
        return $2whNH.map($2whNH.map($bygWp.maybeMakeUrl(url), function(prim) {
            return prim.pathname;
        }), function(prim) {
            return prim.toLowerCase();
        });
    } catch (exn) {
        return;
    }
}
function $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories) {
    if (urlPathname === "/") return;
    var l1Match = topLevelCategories.find(function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var link = $1xf0g.getCategoryLink(cat);
        if (link !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(link));
        else return false;
    });
    var l1Match$1 = l1Match === undefined ? undefined : $loT9g.some(l1Match);
    var l2OrDeeperMatch = $1xf0g.findCategoryBy(topLevelCategories, function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var match = $1xf0g.getCategoryLink(cat);
        if (l1Match !== undefined) {
            if (match !== undefined && $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match))) return l1Match.id !== cat.id;
            else return false;
        } else if (match !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match));
        else return false;
    });
    if (l2OrDeeperMatch !== undefined) return l2OrDeeperMatch;
    else return l1Match$1;
}
function $fb9ef608eb76e9b2$export$7f3d9773c89e0196(topLevelCategories, category) {
    return $1xf0g.getCategoryParentById(topLevelCategories, category.id);
}
function $fb9ef608eb76e9b2$export$2b5083f21a7660c3(categories, fallback) {
    if ($i7mYY.keep(categories, function(category) {
        return category.visibleInMenuBar;
    }).length === 0) return fallback;
    else return categories;
}
function $fb9ef608eb76e9b2$export$fd42e504a4d8f825(drawerState, embedType, urlPathname) {
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var canUseContextualL1s = embedType !== /* Inline */ 1 && settings.contextualL1s && drawerState !== /* Open */ 2 || settings.contextualInline && embedType === /* Inline */ 1;
    if (canUseContextualL1s) return $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, match.categories);
}
function $fb9ef608eb76e9b2$export$f20aa461418ac738(embedType, drawerState, urlPathname) {
    var hasNavigatedAwayFromContextualRoot = $g85JO.useRef(false);
    var match = $8E2YL.use(undefined).config;
    var topLevelCategories = match.categories;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var canUseContextualL1s = (embedType === /* Bottombar */ 0 || embedType === /* Launcher */ 2) && match.settings.contextualL1s && drawerState !== /* Open */ 2;
    if (!canUseContextualL1s) return topLevelCategories;
    var contextualRoot = $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories);
    var isInRootsOrParentPath;
    if (contextualRoot !== undefined) {
        var isRootPLP = $1xf0g.isPLP(contextualRoot);
        var inRootsPath = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
            return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
        }).some(function(cat) {
            return cat.id === contextualRoot.id;
        });
        if (inRootsPath) isInRootsOrParentPath = true;
        else {
            var tmp = false;
            if (isRootPLP) {
                var rootParent = $1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id);
                tmp = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
                    return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
                }).some(function(cat) {
                    return cat.id === $2whNH.mapWithDefault(rootParent, "", function(parent) {
                        return parent.id;
                    });
                });
            }
            isInRootsOrParentPath = tmp;
        }
    } else isInRootsOrParentPath = false;
    if (!isInRootsOrParentPath && drawerState === /* Open */ 2) hasNavigatedAwayFromContextualRoot.current = true;
    if (drawerState === /* Closed */ 0) hasNavigatedAwayFromContextualRoot.current = false;
    var canUseContextualL1s$1 = canUseContextualL1s && (drawerState === /* Closed */ 0 || isInRootsOrParentPath) && (drawerState === /* Closed */ 0 || !hasNavigatedAwayFromContextualRoot.current);
    if (contextualRoot === undefined) return topLevelCategories;
    if (!canUseContextualL1s$1) return topLevelCategories;
    var match$1 = contextualRoot.listPageActiveLayout;
    var isPLP;
    isPLP = typeof match$1 === "number" || match$1.TAG !== /* ProductGrid */ 3 ? false : true;
    if (isPLP) return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($2whNH.mapWithDefault($1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id), topLevelCategories, $1xf0g.getChildren), topLevelCategories);
    else return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($1xf0g.getChildren(contextualRoot), topLevelCategories);
}
 /* react Not a pure module */ 
});

parcelRegister("6e14p", function(module, exports) {

$parcel$export(module.exports, "useIsStyleLoaded", function () { return $4884e15e200d2e55$export$adadf97df3f958bb; });
$parcel$export(module.exports, "makeProps", function () { return $4884e15e200d2e55$export$d4ee11730f14c667; });
$parcel$export(module.exports, "make", function () { return $4884e15e200d2e55$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $hrFTE = parcelRequire("hrFTE");
function $4884e15e200d2e55$export$3c892654f38bd67d(param) {
    var match = $g85JO.useState(function() {
        return false;
    });
    var setStyleLoaded = match[1];
    $g85JO.useEffect(function() {
        $hrFTE.insertCSS(function(param) {
            $iv6Yc._1(setStyleLoaded, function(param) {
                return true;
            });
        }, undefined);
    }, []);
    return match[0];
}
var $4884e15e200d2e55$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext(false);
var $4884e15e200d2e55$var$provider = $4884e15e200d2e55$export$a078c61943f9dbbe.Provider;
function $4884e15e200d2e55$var$CriticalCSSProvider$Provider(Props) {
    var children = Props.children;
    var isStyleLoaded = $4884e15e200d2e55$export$3c892654f38bd67d(undefined);
    return /*#__PURE__*/ $g85JO.createElement($4884e15e200d2e55$var$provider, {
        value: isStyleLoaded,
        children: children
    });
}
$4884e15e200d2e55$var$CriticalCSSProvider$Provider.displayName = "CriticalCSSProvider.Provider";
var $4884e15e200d2e55$export$2881499e37b75b9a = {
    provider: $4884e15e200d2e55$var$provider,
    make: $4884e15e200d2e55$var$CriticalCSSProvider$Provider
};
function $4884e15e200d2e55$export$adadf97df3f958bb(param) {
    return $g85JO.useContext($4884e15e200d2e55$export$a078c61943f9dbbe);
}
function $4884e15e200d2e55$export$d4ee11730f14c667(prim0, prim1, prim2) {
    var tmp = {
        children: prim0
    };
    if (prim1 !== undefined) tmp.key = prim1;
    return tmp;
}
var $4884e15e200d2e55$export$dd44f18ab656f3bb = $4884e15e200d2e55$var$CriticalCSSProvider$Provider;
 /* context Not a pure module */ 
});

parcelRegister("8adqh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5f19ab6e1e369baa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $5f19ab6e1e369baa$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("kBydv"));
});
function $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($5f19ab6e1e369baa$var$component, Props);
}
$5f19ab6e1e369baa$var$MiniCartDrawer_Lazy.displayName = "MiniCartDrawer_Lazy";
var $5f19ab6e1e369baa$export$dd44f18ab656f3bb = $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("kBydv", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("ebd07"))
]).then(function() {
    return parcelRequire("67Br4");
});

});


parcelRegister("fCgIf", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $b5e75e6738c82fab$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");

var $5RX6O = parcelRequire("5RX6O");

var $ij6do = parcelRequire("ij6do");
function $b5e75e6738c82fab$export$e8aa07cf2e863b75(url, topLevelCategories) {
    var regex = new RegExp("https://.+/.+/(ig|instagram|tiktok|tt|shop)", "i");
    var slug = $2whNH.getWithDefault($2whNH.getWithDefault($2whNH.mapWithDefault($loT9g.null_to_opt(url.match(regex)), undefined, function(__x) {
        return $i7mYY.get(__x, 1);
    }), undefined), "");
    var exit = 0;
    switch(slug){
        case "ig":
        case "instagram":
            exit = 1;
            break;
        case "shop":
            var fn = function fn(cat) {
                return cat.title.toLowerCase() === "shop";
            };
            return $loT9g.undefined_to_opt(topLevelCategories.find($iv6Yc.__1(fn)));
        case "tiktok":
        case "tt":
            exit = 2;
            break;
        default:
            return;
    }
    switch(exit){
        case 1:
            return $loT9g.undefined_to_opt(topLevelCategories.find(function(cat) {
                var match = cat.socialNetworkSource;
                if (match !== undefined && match.TAG === /* Instagram */ 0) return true;
                else return false;
            }));
        case 2:
            return $loT9g.undefined_to_opt(topLevelCategories.find(function(cat) {
                var match = cat.socialNetworkSource;
                if (match !== undefined && match.TAG !== /* Instagram */ 0) return true;
                else return false;
            }));
    }
}
function $b5e75e6738c82fab$var$MkrBioRouterProvider(Props) {
    var embedType = Props.embedType;
    var children = Props.children;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var topLevelCategories = config.categories;
    var match$1 = $hBcYV.useRouter(undefined);
    var appliedFilters = match$1.productFilters;
    var appliedSort = match$1.productSort;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var isForcingPLP = $5RX6O.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */ 1;
    var isMkrBioEnabled = config.settings.mkrBio !== undefined;
    var url = window.location.href;
    if (!isMkrBioEnabled) return children;
    var slugCategory = $b5e75e6738c82fab$export$e8aa07cf2e863b75(url, topLevelCategories);
    var firstCategory = $2whNH.getWithDefault($i7mYY.get($i7mYY.keep(topLevelCategories, function(category) {
        return category.visibleInMenuBar;
    }), 0), $ij6do.empty);
    var categoryId = slugCategory !== undefined ? slugCategory.id : firstCategory.id;
    var index = config.settings.indexNode;
    var initialRoute;
    var exit = 0;
    if (index !== undefined && index.visibleInMenuBar) initialRoute = $2whNH.map(slugCategory, function(category) {
        return {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: category.id
                },
                viewPLP: isForcingPLP,
                filters: appliedFilters,
                sort: appliedSort
            }
        };
    });
    else exit = 1;
    if (exit === 1) initialRoute = {
        TAG: /* ListPage */ 1,
        _0: {
            listPageType: {
                TAG: /* Category */ 0,
                _0: categoryId
            },
            viewPLP: isForcingPLP,
            filters: appliedFilters,
            sort: appliedSort
        }
    };
    var tmp = {
        configId: config.id,
        embedType: embedType,
        children: children
    };
    if (initialRoute !== undefined) tmp.defaultInitialRoute = $loT9g.valFromOption(initialRoute);
    return /*#__PURE__*/ $g85JO.createElement($hBcYV.make, tmp);
}
$b5e75e6738c82fab$var$MkrBioRouterProvider.displayName = "MkrBioRouterProvider";
var $b5e75e6738c82fab$export$dd44f18ab656f3bb = $b5e75e6738c82fab$var$MkrBioRouterProvider;
 /* react Not a pure module */ 
});

parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("lSt1Q"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("lSt1Q", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});


parcelRegister("gtaS4", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $bfd7c98ffbabf0bf$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "make", function () { return $bfd7c98ffbabf0bf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d1G6W = parcelRequire("d1G6W");

var $2whNH = parcelRequire("2whNH");

var $kJhYp = parcelRequire("kJhYp");

var $ckFDW = parcelRequire("ckFDW");

var $efwy1 = parcelRequire("efwy1");

var $hm3Un = parcelRequire("hm3Un");
var $bfd7c98ffbabf0bf$export$2cd8252107eb640b = {
    mediaId: undefined,
    aspectRatio: undefined,
    backLocation: undefined,
    time: undefined,
    muted: false,
    setMediaId: undefined,
    saveTime: undefined,
    setMuted: undefined
};
var $bfd7c98ffbabf0bf$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($bfd7c98ffbabf0bf$export$2cd8252107eb640b);
var $bfd7c98ffbabf0bf$var$provider = $bfd7c98ffbabf0bf$export$a078c61943f9dbbe.Provider;
function $bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($bfd7c98ffbabf0bf$var$provider, {
        value: value,
        children: children
    });
}
$bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider.displayName = "PictureInPictureContext.Provider";
var $bfd7c98ffbabf0bf$export$2881499e37b75b9a = {
    provider: $bfd7c98ffbabf0bf$var$provider,
    make: $bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider
};
function $bfd7c98ffbabf0bf$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($bfd7c98ffbabf0bf$export$a078c61943f9dbbe);
}
function $bfd7c98ffbabf0bf$var$PictureInPictureContext(Props) {
    var children = Props.children;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var match$1 = $g85JO.useState(function() {
        return $hm3Un.getFromSessionStorage("mediaId");
    });
    var setMediaId = match$1[1];
    var mediaId = match$1[0];
    var match$2 = $g85JO.useState(function() {
        return $2whNH.flatMap($hm3Un.getFromSessionStorage("aspectRatio"), $d1G6W.fromString);
    });
    var setAspectRatio = match$2[1];
    var aspectRatio = match$2[0];
    var match$3 = $g85JO.useState(function() {
        return $2whNH.isSome($hm3Un.getFromSessionStorage("mediaId"));
    });
    var setMuted = match$3[1];
    var muted = match$3[0];
    var match$4 = $g85JO.useState(function() {
        return $2whNH.flatMap($hm3Un.getFromSessionStorage("time"), $d1G6W.fromString);
    });
    var setTime = match$4[1];
    var time = match$4[0];
    var match$5 = $g85JO.useState(function() {
        return $2whNH.map($hm3Un.getFromSessionStorage("backLocation"), function(param) {
            return $kJhYp.fromUrl(namespace, param);
        });
    });
    var setBackLocation = match$5[1];
    var backLocation = match$5[0];
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("mediaId", $2whNH.getWithDefault(mediaId, ""));
    }, [
        mediaId
    ]);
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("aspectRatio", $2whNH.mapWithDefault(aspectRatio, "", function(prim) {
            return String(prim);
        }));
    }, [
        aspectRatio
    ]);
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("time", $2whNH.mapWithDefault(time, "", function(prim) {
            return String(prim);
        }));
    }, [
        time
    ]);
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("backLocation", $2whNH.mapWithDefault(backLocation, "", function(loc) {
            return window.location.origin + "?" + $kJhYp.toQueryString(namespace, loc);
        }));
    }, [
        backLocation
    ]);
    var saveTime = (0, $ckFDW.default)(function(time) {
        $hm3Un.setToSessionStorage("time", String(time));
    }, 3000);
    var value = $g85JO.useMemo(function() {
        return {
            mediaId: mediaId,
            aspectRatio: aspectRatio,
            backLocation: backLocation,
            time: time,
            muted: muted,
            setMediaId: function setMediaId1(backLocation, time, aspectRatio, mutedOpt, mediaId) {
                var muted = mutedOpt !== undefined ? mutedOpt : false;
                if (mediaId !== undefined) {
                    if (backLocation !== undefined) {
                        var location_quickView = {
                            mediaId: mediaId,
                            mediaParentId: backLocation.quickView.mediaParentId,
                            albumId: undefined,
                            panelClosed: undefined,
                            whichList: undefined,
                            productId: undefined,
                            relatedMediaProductIds: backLocation.quickView.relatedMediaProductIds,
                            relatedMediaCategoryId: backLocation.quickView.relatedMediaCategoryId,
                            variantId: undefined,
                            photoZoom: undefined,
                            time: undefined
                        };
                        var location_quickNav = backLocation.quickNav;
                        var $$location = {
                            quickView: location_quickView,
                            quickNav: location_quickNav
                        };
                        $iv6Yc._1(setBackLocation, function(param) {
                            return $$location;
                        });
                    } else {
                        var $$location$1 = $kJhYp.fromUrl(namespace, window.location.href);
                        $kJhYp.goTo(namespace, undefined, undefined, $$location$1.quickNav, undefined, undefined, undefined);
                        $iv6Yc._1(setBackLocation, function(param) {
                            return $$location$1;
                        });
                    }
                } else if (backLocation !== undefined) {
                    var quickView = backLocation.quickView;
                    var quickView_mediaId = quickView.mediaId;
                    var quickView_mediaParentId = quickView.mediaParentId;
                    var quickView_albumId = quickView.albumId;
                    var quickView_panelClosed = quickView.panelClosed;
                    var quickView_whichList = quickView.whichList;
                    var quickView_productId = quickView.productId;
                    var quickView_relatedMediaProductIds = quickView.relatedMediaProductIds;
                    var quickView_relatedMediaCategoryId = quickView.relatedMediaCategoryId;
                    var quickView_variantId = quickView.variantId;
                    var quickView_photoZoom = quickView.photoZoom;
                    var quickView$1 = {
                        mediaId: quickView_mediaId,
                        mediaParentId: quickView_mediaParentId,
                        albumId: quickView_albumId,
                        panelClosed: quickView_panelClosed,
                        whichList: quickView_whichList,
                        productId: quickView_productId,
                        relatedMediaProductIds: quickView_relatedMediaProductIds,
                        relatedMediaCategoryId: quickView_relatedMediaCategoryId,
                        variantId: quickView_variantId,
                        photoZoom: quickView_photoZoom,
                        time: time
                    };
                    $kJhYp.goTo(namespace, undefined, quickView$1, backLocation.quickNav, undefined, undefined, undefined);
                    $iv6Yc._1(setBackLocation, function(param) {});
                } else $iv6Yc._1(setBackLocation, function(param) {});
                $iv6Yc._1(setMediaId, function(param) {
                    return mediaId;
                });
                $iv6Yc._1(setTime, function(param) {
                    return time;
                });
                $iv6Yc._1(setMuted, function(param) {
                    return muted;
                });
                if (aspectRatio !== undefined) return $iv6Yc._1(setAspectRatio, function(param) {
                    return aspectRatio;
                });
            },
            saveTime: saveTime,
            setMuted: function setMuted1(value) {
                $iv6Yc._1(setMuted, function(param) {
                    return value;
                });
            }
        };
    }, [
        mediaId,
        aspectRatio,
        $2whNH.map(backLocation, function(param) {
            return $kJhYp.toQueryString(namespace, param);
        }),
        time,
        muted
    ]);
    return /*#__PURE__*/ $g85JO.createElement($bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider, {
        value: value,
        children: children
    });
}
$bfd7c98ffbabf0bf$var$PictureInPictureContext.displayName = "PictureInPictureContext";
var $bfd7c98ffbabf0bf$export$dd44f18ab656f3bb = $bfd7c98ffbabf0bf$var$PictureInPictureContext;
 /* context Not a pure module */ 
});
parcelRegister("ckFDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa7a7c95612752e$export$2e2bcd8739ae039; });

var $g0DOt = parcelRequire("g0DOt");

var $iYlcu = parcelRequire("iYlcu");
/** Error message constants. */ var $8fa7a7c95612752e$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $8fa7a7c95612752e$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($8fa7a7c95612752e$var$FUNC_ERROR_TEXT);
    if ((0, $iYlcu.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $g0DOt.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $8fa7a7c95612752e$export$2e2bcd8739ae039 = $8fa7a7c95612752e$var$throttle;

});
parcelRegister("g0DOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba7b877d63b6054e$export$2e2bcd8739ae039; });

var $iYlcu = parcelRequire("iYlcu");

var $92qkg = parcelRequire("92qkg");

var $flcGD = parcelRequire("flcGD");
/** Error message constants. */ var $ba7b877d63b6054e$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ba7b877d63b6054e$var$nativeMax = Math.max, $ba7b877d63b6054e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ba7b877d63b6054e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ba7b877d63b6054e$var$FUNC_ERROR_TEXT);
    wait = (0, $flcGD.default)(wait) || 0;
    if ((0, $iYlcu.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ba7b877d63b6054e$var$nativeMax((0, $flcGD.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ba7b877d63b6054e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $92qkg.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $92qkg.default)());
    }
    function debounced() {
        var time = (0, $92qkg.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $ba7b877d63b6054e$export$2e2bcd8739ae039 = $ba7b877d63b6054e$var$debounce;

});
parcelRegister("iYlcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcfe469055918527$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $gfRPo = parcelRequire("gfRPo");
function $dcfe469055918527$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value);
    return value != null && (type == "object" || type == "function");
}
var $dcfe469055918527$export$2e2bcd8739ae039 = $dcfe469055918527$var$isObject;

});

parcelRegister("92qkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6948b8bba5c9c483$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6948b8bba5c9c483$var$now = function now() {
    return (0, $enmTs.default).Date.now();
};
var $6948b8bba5c9c483$export$2e2bcd8739ae039 = $6948b8bba5c9c483$var$now;

});
parcelRegister("enmTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b36f5e631d88f5$export$2e2bcd8739ae039; });

var $igP3b = parcelRequire("igP3b");
/** Detect free variable `self`. */ var $02b36f5e631d88f5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $02b36f5e631d88f5$var$root = (0, $igP3b.default) || $02b36f5e631d88f5$var$freeSelf || Function("return this")();
var $02b36f5e631d88f5$export$2e2bcd8739ae039 = $02b36f5e631d88f5$var$root;

});
parcelRegister("igP3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4d152269e8defce$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d4d152269e8defce$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d4d152269e8defce$export$2e2bcd8739ae039 = $d4d152269e8defce$var$freeGlobal;

});



parcelRegister("flcGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b2a881acb233f6$export$2e2bcd8739ae039; });

var $7bKHP = parcelRequire("7bKHP");

var $iYlcu = parcelRequire("iYlcu");

var $9WZwf = parcelRequire("9WZwf");
/** Used as references for various `Number` constants. */ var $b2b2a881acb233f6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $b2b2a881acb233f6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b2b2a881acb233f6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b2b2a881acb233f6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b2b2a881acb233f6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b2b2a881acb233f6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $9WZwf.default)(value)) return $b2b2a881acb233f6$var$NAN;
    if ((0, $iYlcu.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $iYlcu.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $7bKHP.default)(value);
    var isBinary = $b2b2a881acb233f6$var$reIsBinary.test(value);
    return isBinary || $b2b2a881acb233f6$var$reIsOctal.test(value) ? $b2b2a881acb233f6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b2b2a881acb233f6$var$reIsBadHex.test(value) ? $b2b2a881acb233f6$var$NAN : +value;
}
var $b2b2a881acb233f6$export$2e2bcd8739ae039 = $b2b2a881acb233f6$var$toNumber;

});
parcelRegister("7bKHP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53bdca4c640065b2$export$2e2bcd8739ae039; });

var $hVIkI = parcelRequire("hVIkI");
/** Used to match leading whitespace. */ var $53bdca4c640065b2$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $53bdca4c640065b2$var$baseTrim(string) {
    return string ? string.slice(0, (0, $hVIkI.default)(string) + 1).replace($53bdca4c640065b2$var$reTrimStart, "") : string;
}
var $53bdca4c640065b2$export$2e2bcd8739ae039 = $53bdca4c640065b2$var$baseTrim;

});
parcelRegister("hVIkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0da26260aa88ea2$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $d0da26260aa88ea2$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d0da26260aa88ea2$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d0da26260aa88ea2$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d0da26260aa88ea2$export$2e2bcd8739ae039 = $d0da26260aa88ea2$var$trimmedEndIndex;

});


parcelRegister("9WZwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e9403b864b7e92$export$2e2bcd8739ae039; });

var $gfRPo = parcelRequire("gfRPo");

var $gEvC5 = parcelRequire("gEvC5");

var $2pW4B = parcelRequire("2pW4B");
/** `Object#toString` result references. */ var $73e9403b864b7e92$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $73e9403b864b7e92$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value)) == "symbol" || (0, $2pW4B.default)(value) && (0, $gEvC5.default)(value) == $73e9403b864b7e92$var$symbolTag;
}
var $73e9403b864b7e92$export$2e2bcd8739ae039 = $73e9403b864b7e92$var$isSymbol;

});
parcelRegister("gEvC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f8e78702c28b95$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");

var $drSKx = parcelRequire("drSKx");

var $gu259 = parcelRequire("gu259");
/** `Object#toString` result references. */ var $c1f8e78702c28b95$var$nullTag = "[object Null]", $c1f8e78702c28b95$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $c1f8e78702c28b95$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c1f8e78702c28b95$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c1f8e78702c28b95$var$undefinedTag : $c1f8e78702c28b95$var$nullTag;
    return $c1f8e78702c28b95$var$symToStringTag && $c1f8e78702c28b95$var$symToStringTag in Object(value) ? (0, $drSKx.default)(value) : (0, $gu259.default)(value);
}
var $c1f8e78702c28b95$export$2e2bcd8739ae039 = $c1f8e78702c28b95$var$baseGetTag;

});
parcelRegister("155hF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9a5b621e5301b6$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/** Built-in value references. */ var $0c9a5b621e5301b6$var$Symbol = (0, $enmTs.default).Symbol;
var $0c9a5b621e5301b6$export$2e2bcd8739ae039 = $0c9a5b621e5301b6$var$Symbol;

});

parcelRegister("drSKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca84417f00d2331$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");
/** Used for built-in method references. */ var $9ca84417f00d2331$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ca84417f00d2331$var$hasOwnProperty = $9ca84417f00d2331$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9ca84417f00d2331$var$nativeObjectToString = $9ca84417f00d2331$var$objectProto.toString;
/** Built-in value references. */ var $9ca84417f00d2331$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9ca84417f00d2331$var$getRawTag(value) {
    var isOwn = $9ca84417f00d2331$var$hasOwnProperty.call(value, $9ca84417f00d2331$var$symToStringTag), tag = value[$9ca84417f00d2331$var$symToStringTag];
    try {
        value[$9ca84417f00d2331$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9ca84417f00d2331$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9ca84417f00d2331$var$symToStringTag] = tag;
        else delete value[$9ca84417f00d2331$var$symToStringTag];
    }
    return result;
}
var $9ca84417f00d2331$export$2e2bcd8739ae039 = $9ca84417f00d2331$var$getRawTag;

});

parcelRegister("gu259", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0011029f37088ab$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $c0011029f37088ab$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c0011029f37088ab$var$nativeObjectToString = $c0011029f37088ab$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c0011029f37088ab$var$objectToString(value) {
    return $c0011029f37088ab$var$nativeObjectToString.call(value);
}
var $c0011029f37088ab$export$2e2bcd8739ae039 = $c0011029f37088ab$var$objectToString;

});


parcelRegister("2pW4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c2af6b3f01b3b43$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c2af6b3f01b3b43$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $1c2af6b3f01b3b43$export$2e2bcd8739ae039 = $1c2af6b3f01b3b43$var$isObjectLike;

});






parcelRegister("hM6fK", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $cf0bc514c141a324$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $cf0bc514c141a324$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $cf0bc514c141a324$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("gkuBW"));
});
function $cf0bc514c141a324$var$ProductDetailsPage_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($cf0bc514c141a324$var$component, Props);
}
$cf0bc514c141a324$var$ProductDetailsPage_Lazy.displayName = "ProductDetailsPage_Lazy";
var $cf0bc514c141a324$export$513ccb98c53b8039 = $cf0bc514c141a324$var$component.preload;
var $cf0bc514c141a324$export$dd44f18ab656f3bb = $cf0bc514c141a324$var$ProductDetailsPage_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("gkuBW", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("WepAH"))
]).then(function() {
    return parcelRequire("Tbt6s");
});

});



parcelRegister("dJhID", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9fed38edae7c024d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $hPrj9 = parcelRequire("hPrj9");

var $3GntQ = parcelRequire("3GntQ");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $75ZqT = parcelRequire("75ZqT");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $4QdUt = parcelRequire("4QdUt");
var $9fed38edae7c024d$export$20dc868c9a130faa = $75ZqT.$$Error.fromRescriptWithNewMessage;
var $9fed38edae7c024d$var$_ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $hPrj9._)(_ErrorBoundary, _React_Component);
    var _super = (0, $3GntQ._)(_ErrorBoundary);
    function _ErrorBoundary(props) {
        (0, $6Tsgf._)(this, _ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: false,
            errorInfo: null
        };
        return _this;
    }
    (0, $hmsbi._)(_ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // If we detect that the error is a rescript exception, we try to extract information out of it,
                // and create a new error object with it's RE_EXN_ID as the message.
                if (typeof error.RE_EXN_ID == "string" && typeof error.Error == "object") error = $9fed38edae7c024d$export$20dc868c9a130faa(error, error.RE_EXN_ID);
                // Do nothing if the error is thrown by parcel script loader.
                // This error usually indicates network issues.
                if (error.message.includes("Failed to fetch dynamically imported module:") || error.message.includes("Cannot find module") || error.message.includes("Could not resolve bundle with id")) return;
                this.setState({
                    error: error,
                    errorInfo: errorInfo
                });
                if (this.props.onError) this.props.onError(error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.error) return this.props.renderFallback ? this.props.renderFallback(this.state.error, this.state.errorInfo) : null;
                else return this.props.children;
            }
        }
    ]);
    return _ErrorBoundary;
}($g85JO.Component);
function $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary(Props) {
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$_ErrorBoundary, Props);
}
$9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary.displayName = "ErrorBoundary.RawErrorBoundary";
var $9fed38edae7c024d$export$e022a45c7a286b77 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary
};
function $9fed38edae7c024d$export$b42e70ddca33ff5b(str) {
    if (str !== "") return str;
}
function $9fed38edae7c024d$var$ErrorBoundary$ReportOnce(Props) {
    var error = Props.error;
    var redirect = Props.redirect;
    var componentStack = Props.componentStack;
    var message = Props.message;
    $g85JO.useEffect(function() {
        $4QdUt.critical2(error, {
            message: message,
            componentStack: componentStack
        });
        var timeout = redirect !== undefined ? $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(redirect, undefined);
        }, 0)) : undefined;
        return function(param) {
            $2whNH.forEach(timeout, function(id) {
                clearTimeout(id);
            });
        };
    }, []);
    return null;
}
$9fed38edae7c024d$var$ErrorBoundary$ReportOnce.displayName = "ErrorBoundary.ReportOnce";
var $9fed38edae7c024d$export$f2fa74dfba7f4e57 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$ReportOnce
};
function $9fed38edae7c024d$var$ErrorBoundary(Props) {
    var componentName = Props.componentName;
    var redirect = Props.redirect;
    var children = Props.children;
    var renderFallback = function renderFallback(internalError, info) {
        var cause = $75ZqT.$$Error.fromRescript(internalError);
        var rootCause = $75ZqT.$$Error.getRootCause(cause);
        var rootCauseName = rootCause.name;
        var rootCauseMessage = rootCause.message;
        var culprit = $2whNH.getWithDefault($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map(info.componentStack, function(__x) {
            return __x.replace(/\n/g, "");
        }), function(__x) {
            return __x.split(" in ");
        }), function(__x) {
            return $i7mYY.get(__x, 1);
        }), function(__x) {
            return __x.replace(/\(([^\)]+)\)/g, "");
        }), function(prim) {
            return prim.trim();
        }), $9fed38edae7c024d$export$b42e70ddca33ff5b), function(culprit) {
            return "<" + culprit + "> crashed, " + componentName + " caught";
        }), componentName + " caught a crash");
        var rootCauseMessage$1 = rootCauseName !== undefined ? rootCauseMessage !== undefined ? "RC: " + rootCauseName + " " + rootCauseMessage : "RC: " + rootCauseName : rootCauseMessage !== undefined ? "RC: " + rootCauseMessage : undefined;
        var message = $i7mYY.keepMap([
            culprit,
            rootCauseMessage$1
        ], function(a) {
            return a;
        }).join(", ");
        var error = $75ZqT.$$Error.fromStringWithCause(message, rootCause);
        var tmp = {
            error: error,
            componentStack: info.componentStack,
            message: message
        };
        if (redirect !== undefined) tmp.redirect = $loT9g.valFromOption(redirect);
        return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$ReportOnce, tmp);
    };
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary, {
        children: children,
        renderFallback: renderFallback
    });
}
$9fed38edae7c024d$var$ErrorBoundary.displayName = "ErrorBoundary";
var $9fed38edae7c024d$export$dd44f18ab656f3bb = $9fed38edae7c024d$var$ErrorBoundary;
 /*  Not a pure module */ 
});


parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("2Mb3w", function(module, exports) {

$parcel$export(module.exports, "getBrowser", function () { return $2058a3ec51237c4b$export$89e15fc796a4a429; });
$parcel$export(module.exports, "isSafariVersion__16_3", function () { return $2058a3ec51237c4b$export$91773661b17fb447; });
$parcel$export(module.exports, "getOS", function () { return $2058a3ec51237c4b$export$34ee789f81ad4cb9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");
var $2058a3ec51237c4b$export$60cc2146340a7149 = function getAppVersion() {
    return navigator.appVersion;
};
var $2058a3ec51237c4b$export$7935961ef7719cb0 = function getUserAgent() {
    return navigator.userAgent;
};
function $2058a3ec51237c4b$export$89e15fc796a4a429(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var chromeAgent = userAgentString.indexOf("Chrome") > -1;
    var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
    var safariAgent = userAgentString.indexOf("Safari") > -1;
    if (chromeAgent) return /* Chrome */ 0;
    else if (firefoxAgent) return /* Firefox */ 2;
    else if (safariAgent) return /* Safari */ 1;
    else return /* UnknownBrowser */ 3;
}
function $2058a3ec51237c4b$export$91773661b17fb447(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var match = $2058a3ec51237c4b$export$89e15fc796a4a429(undefined);
    if (match !== 1) return false;
    else return userAgentString.includes("iPhone OS 16_3");
}
function $2058a3ec51237c4b$export$34ee789f81ad4cb9(param) {
    var appVersion = $iv6Yc._1($2058a3ec51237c4b$export$60cc2146340a7149, undefined);
    if (appVersion.includes("Win")) return /* Windows */ 1;
    else if (appVersion.includes("iPhone OS")) return /* IOS */ 3;
    else if (appVersion.includes("Mac")) return /* Mac */ 0;
    else if (appVersion.includes("Linux")) return /* Linux */ 2;
    else return /* UnknownOs */ 4;
}
 /* No side effect */ 
});

parcelRegister("2XXXw", function(module, exports) {

$parcel$export(module.exports, "ScrollRestorationLocalStorage", function () { return $228f9a1798c51d97$export$791f6fca0d60efd9; });
$parcel$export(module.exports, "setBreakingPoint", function () { return $228f9a1798c51d97$export$1dfa5e58b4233c3; });
$parcel$export(module.exports, "removeBreakingPoint", function () { return $228f9a1798c51d97$export$16e7fafba7e176d; });
$parcel$export(module.exports, "setCurrentScroll", function () { return $228f9a1798c51d97$export$6e32c7a2bca8fb40; });
$parcel$export(module.exports, "getClosestBreakingPoint", function () { return $228f9a1798c51d97$export$69a851a551f434f5; });
$parcel$export(module.exports, "setScrollLock", function () { return $228f9a1798c51d97$export$a2324b57a6a5ec84; });
$parcel$export(module.exports, "clearScrollLock", function () { return $228f9a1798c51d97$export$14e0addec6650b88; });
$parcel$export(module.exports, "getScroll", function () { return $228f9a1798c51d97$export$ff41c598de81c14a; });
$parcel$export(module.exports, "isBlockingOnScrollEvent", function () { return $228f9a1798c51d97$export$51e57029e6716073; });
$parcel$export(module.exports, "useScrollRestoration", function () { return $228f9a1798c51d97$export$c4ffdfe23dd48040; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $79vie = parcelRequire("79vie");

var $58Tj9 = parcelRequire("58Tj9");

var $jVmMx = parcelRequire("jVmMx");

var $kJhYp = parcelRequire("kJhYp");

var $gO2mJ = parcelRequire("gO2mJ");

var $8wpG4 = parcelRequire("8wpG4");

var $efwy1 = parcelRequire("efwy1");

var $25dxq = parcelRequire("25dxq");
$gO2mJ.setScrollRestoration("manual");
function $228f9a1798c51d97$export$a91724a679733655(position) {
    if (typeof position === "number") return $iv6Yc._2($jVmMx.Encode.array, [
        "Zero"
    ], $jVmMx.Encode.string);
    else if (position.TAG === /* Pixels */ 0) return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Pixels", $jVmMx.Encode.$$int);
    else return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Index", $jVmMx.Encode.$$int);
}
var $228f9a1798c51d97$var$zero = $79vie.map($79vie.index(0, $jVmMx.Decode.exactString("Zero")), function(param) {
    return /* Zero */ 0;
});
var $228f9a1798c51d97$var$pixels = $jVmMx.Decode.deccoVariantWithPayload("Pixels", $79vie.$$int, function(v) {
    return {
        TAG: /* Pixels */ 0,
        _0: v
    };
});
var $228f9a1798c51d97$var$index = $jVmMx.Decode.deccoVariantWithPayload("Index", $79vie.$$int, function(v) {
    return {
        TAG: /* Index */ 1,
        _0: v
    };
});
var $228f9a1798c51d97$export$932a824d711ed6ad = $79vie.oneOf($228f9a1798c51d97$var$zero, [
    $228f9a1798c51d97$var$pixels,
    $228f9a1798c51d97$var$index
]);
function $228f9a1798c51d97$var$set(key, value) {
    $8wpG4.set(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }, JSON.stringify($228f9a1798c51d97$export$a91724a679733655(value)));
}
function $228f9a1798c51d97$var$$$delete(key) {
    $8wpG4.$$delete(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    });
}
function $228f9a1798c51d97$var$get(key) {
    return $2whNH.mapWithDefault($8wpG4.get(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }), /* Zero */ 0, function(position) {
        var result = $79vie.decodeValue(JSON.parse(position), $228f9a1798c51d97$export$932a824d711ed6ad);
        if (result.TAG === /* Ok */ 0) return result._0;
        else return /* Zero */ 0;
    });
}
var $228f9a1798c51d97$export$791f6fca0d60efd9 = {
    set: $228f9a1798c51d97$var$set,
    $$delete: $228f9a1798c51d97$var$$$delete,
    get: $228f9a1798c51d97$var$get
};
var $228f9a1798c51d97$export$f3a17d4d921911b3 = {};
var $228f9a1798c51d97$export$d4351b0ee1c8c8c6 = {
    contents: undefined
};
var $228f9a1798c51d97$export$1f6d3e4fc8cedc8e = {
    contents: {}
};
function $228f9a1798c51d97$export$6bbf62f168c1dddc($$location, id, position) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($$location));
    var bucket = $d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey);
    $228f9a1798c51d97$var$set(id, position);
    if (bucket !== undefined) $loT9g.valFromOption(bucket)[id] = position;
    else $228f9a1798c51d97$export$f3a17d4d921911b3[bucketKey] = $d3YYW.fromArray([
        [
            id,
            position
        ]
    ]);
}
function $228f9a1798c51d97$export$1dfa5e58b4233c3(paddingOpt, id, center) {
    var padding = paddingOpt !== undefined ? paddingOpt : 0;
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents[id] = {
        center: center,
        padding: padding
    };
}
function $228f9a1798c51d97$export$16e7fafba7e176d(idToDelete) {
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents = $d3YYW.fromArray($i7mYY.keepMap($d3YYW.entries($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(param) {
        var id = param[0];
        if (id !== idToDelete) return [
            id,
            param[1]
        ];
    }));
}
function $228f9a1798c51d97$export$684cfbe7f928b61e(param) {
    return $58Tj9.stableSortBy($d3YYW.values($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(a, b) {
        if (a.center > b.center) return 1;
        else if (a.center < b.center) return -1;
        else return 0;
    });
}
function $228f9a1798c51d97$export$6e32c7a2bca8fb40(namespace, id, target) {
    $228f9a1798c51d97$export$6bbf62f168c1dddc($kJhYp.getStatesByNamespace(namespace).current, id, target);
}
function $228f9a1798c51d97$export$69a851a551f434f5(currentScroll, targetScroll) {
    var allPoints = $228f9a1798c51d97$export$684cfbe7f928b61e(undefined);
    return $i7mYY.reduce(allPoints, targetScroll, function(prev, curr) {
        if ((curr.center - curr.padding | 0) <= currentScroll && (curr.center + curr.padding | 0) >= currentScroll) return currentScroll;
        else if (curr.center <= currentScroll) return curr.center;
        else return prev;
    });
}
function $228f9a1798c51d97$export$a2324b57a6a5ec84(dref) {
    $2whNH.map($loT9g.nullable_to_opt(dref.current), function(el) {
        $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = {
            element: el,
            boundingClientRect: el.getBoundingClientRect()
        };
    });
}
function $228f9a1798c51d97$export$14e0addec6650b88(param) {
    $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = undefined;
}
function $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, id) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    var fromBucket = $2whNH.flatMap($d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey), function(bucket) {
        return $d3YYW.get(bucket, id);
    });
    if (fromBucket !== undefined) return fromBucket;
    if (!localStorage) return /* Zero */ 0;
    var fromLocalStorage = $228f9a1798c51d97$var$get(id);
    $228f9a1798c51d97$var$$$delete(id);
    return fromLocalStorage;
}
var $228f9a1798c51d97$export$398994a7cd250b7e = {
    contents: false
};
function $228f9a1798c51d97$export$aded8d3ce7fe43e1(bool) {
    $228f9a1798c51d97$export$398994a7cd250b7e.contents = bool;
}
function $228f9a1798c51d97$export$51e57029e6716073(param) {
    return $228f9a1798c51d97$export$398994a7cd250b7e.contents;
}
function $228f9a1798c51d97$export$c4ffdfe23dd48040(id) {
    var timeoutRef = $g85JO.useRef(undefined);
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var getInitialResult = function getInitialResult(localStorage) {
        return {
            position: $2whNH.getWithDefault($2whNH.map(id, function(param) {
                return $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, param);
            }), /* Zero */ 0),
            lock: undefined
        };
    };
    var getCurrentKey = function getCurrentKey(param) {
        return $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    };
    var key = $g85JO.useRef(getCurrentKey(undefined));
    $g85JO.useEffect(function() {
        return function(param) {
            $2whNH.forEach(timeoutRef.current, function(prim) {
                clearTimeout(prim);
            });
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return getInitialResult(false);
    });
    var setResult = match$1[1];
    var setResult$1 = function setResult$1(fn) {
        $228f9a1798c51d97$export$398994a7cd250b7e.contents = true;
        $iv6Yc._1(setResult, fn);
        timeoutRef.current = $loT9g.some(setTimeout(function(param) {
            $228f9a1798c51d97$export$398994a7cd250b7e.contents = false;
        }, 100));
    };
    $25dxq.useBrowserNavigation(function(navigationType) {
        if (navigationType !== 1) return $2whNH.forEach(id, $228f9a1798c51d97$var$$$delete);
        var nextResult = getInitialResult(true);
        var match = nextResult.position;
        var nextResultValue = typeof match === "number" ? 0 : match._0;
        setResult$1(function(previousResult) {
            var match = previousResult.position;
            if (typeof match === "number" || match._0 < nextResultValue) return nextResult;
            else return previousResult;
        });
    }, []);
    $g85JO.useEffect(function() {
        setResult$1(function(param) {
            return getInitialResult(false);
        });
    }, [
        id
    ]);
    var update = function update(param) {
        if (id === undefined) return;
        var nextKey = getCurrentKey(undefined);
        if (key.current !== nextKey) {
            setResult$1(function(param) {
                return {
                    position: $228f9a1798c51d97$export$ff41c598de81c14a(namespace, false, id),
                    lock: $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents
                };
            });
            key.current = nextKey;
            return;
        }
    };
    $g85JO.useEffect(function() {
        $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.concat($kJhYp.getStatesByNamespace(namespace).localCallbacks, [
            update
        ]));
        return function(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.keep($kJhYp.getStatesByNamespace(namespace).localCallbacks, function(fn) {
                return fn !== update;
            }));
        };
    }, []);
    return match$1[0];
}
 /*  Not a pure module */ 
});
parcelRegister("8wpG4", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $63453ae6f4ab9cfc$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "$$delete", function () { return $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $63453ae6f4ab9cfc$export$a47fb462a08de82f(key) {
    if (typeof key === "object") {
        var variant = key.NAME;
        if (variant === "optimizeVariant") return "mkr_variant__" + key.VAL + "";
        if (variant === "clientId") return "mkr_client_id__" + key.VAL + "";
    } else {
        if (key === "legacyClientId") return "mkr_client_id";
        if (key === "optimizePreviousEvents") return "mkr_experience_impression";
    }
    var tmp;
    if (typeof key === "object") {
        var variant$1 = key.NAME;
        tmp = variant$1 === "optimizeVariant" ? "optimizeVariant" : variant$1 === "scrollRestoration" ? "scroll-" + key.VAL : variant$1 === "history" ? "history" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "clientId" ? "clientId" : variant$1 === "favorites" ? "favorites" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "selectedMarket" ? "selectedMarket-" + key.VAL : "cart-" + key.VAL;
    } else tmp = key === "debuggerAllowed" ? "debuggerAllowed" : key === "navMenuConfig" ? "navMenuConfig" : key === "legacyClientId" ? "clientId" : key === "gridColumns" ? "gridColumns" : key === "optimizePreviousEvents" ? "optimizePreviousEvents" : "intro";
    return "smartnav__v" + String(2) + "__" + tmp;
}
function $63453ae6f4ab9cfc$export$3988ae62b71be9a3(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            return $2whNH.flatMap($loT9g.null_to_opt($2whNH.getWithDefault(storage, localStorage).getItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key))), function(value) {
                if (value === "") return;
                else return value;
            });
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be(_storage, key, value) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).setItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key), value);
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).removeItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key));
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
var $63453ae6f4ab9cfc$export$83d89fbfd8236492 = 2;
 /* No side effect */ 
});

parcelRegister("25dxq", function(module, exports) {

$parcel$export(module.exports, "useBrowserNavigation", function () { return $18468cc594e5b21b$export$e8c1c060dda75c72; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2Mb3w = parcelRequire("2Mb3w");

var $052u6 = parcelRequire("052u6");
function $18468cc594e5b21b$var$useSafariHack(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : false;
    $052u6.LegacyNavigationTiming.useLegacyNavigationTiming(enabled, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
var $18468cc594e5b21b$export$e02aa0e39cbdc151 = {
    useSafariHack: $18468cc594e5b21b$var$useSafariHack
};
function $18468cc594e5b21b$export$e8c1c060dda75c72(callback, dependencies) {
    var isSafari = $2Mb3w.getBrowser(undefined) === /* Safari */ 1;
    $18468cc594e5b21b$var$useSafariHack(isSafari, callback, dependencies);
    $052u6.usePerformanceObserver1(!isSafari, true, /* Navigation */ 0, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
 /* PerformanceObserver-Showside Not a pure module */ 
});
parcelRegister("052u6", function(module, exports) {

$parcel$export(module.exports, "LegacyNavigationTiming", function () { return $00f26519795813cb$export$127e32ccb8a6e066; });
$parcel$export(module.exports, "usePerformanceObserver1", function () { return $00f26519795813cb$export$d2dfc13adeb0ed2d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $00f26519795813cb$export$48c17662a6902497(param) {
    return $2whNH.isSome(window.PerformanceObserver);
}
function $00f26519795813cb$export$e815e306a6ff66ed(entryType) {
    return "navigation";
}
function $00f26519795813cb$export$2fe53163c7bc4eaf(ext_type) {
    if (ext_type === "back_forward") return /* BackForward */ 1;
    else if (ext_type === "navigate") return /* Navigate */ 0;
    else return /* Reload */ 2;
}
function $00f26519795813cb$export$8ceb1d4b31259502(ext_entry) {
    return {
        _type: $00f26519795813cb$export$2fe53163c7bc4eaf(ext_entry.type)
    };
}
function $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, callback, dependencies) {
    var supported = $2whNH.isSome(window.PerformanceObserver);
    $g85JO.useEffect(function() {
        if (!(enabled && supported)) return;
        var observer = new PerformanceObserver(function(entries) {
            $iv6Yc._1(callback, $i7mYY.map(entries.getEntries(), $00f26519795813cb$export$8ceb1d4b31259502));
        });
        try {
            observer.observe(options);
            var observer$1 = observer;
            return function(param) {
                $2whNH.forEach(observer$1, function(obs) {
                    obs.disconnect();
                });
            };
        } catch (e) {
            return;
        }
    }, dependencies);
}
function $00f26519795813cb$var$useLegacyNavigationTiming(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var callback$1 = function callback$1(e) {
        $2whNH.forEach($2whNH.map($i7mYY.get(window.performance.getEntriesByType("navigation"), 0), function(entry) {
            return {
                _type: $2whNH.getWithDefault(e.persisted, false) ? /* BackForward */ 1 : ({
                    _type: $00f26519795813cb$export$2fe53163c7bc4eaf(entry.type)
                })._type
            };
        }), callback);
    };
    $g85JO.useEffect(function() {
        if (enabled) {
            window.addEventListener("pageshow", callback$1);
            return function(param) {
                window.removeEventListener("pageshow", callback$1);
            };
        }
    }, dependencies);
}
var $00f26519795813cb$export$127e32ccb8a6e066 = {
    useLegacyNavigationTiming: $00f26519795813cb$var$useLegacyNavigationTiming
};
function $00f26519795813cb$export$d2dfc13adeb0ed2d(enabledOpt, bufferedOpt, entryType, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var buffered = bufferedOpt !== undefined ? bufferedOpt : false;
    var options_type = "navigation";
    var options = {
        entryTypes: undefined,
        type: options_type,
        buffered: buffered
    };
    $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, function(entries) {
        $2whNH.forEach($i7mYY.get(entries, 0), callback);
    }, dependencies);
}
 /* react Not a pure module */ 
});



parcelRegister("38gYA", function(module, exports) {

$parcel$export(module.exports, "useScrollableContext", function () { return $247f49975e2c6903$export$c8bd6c217b070147; });
$parcel$export(module.exports, "make", function () { return $247f49975e2c6903$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $3tS2g = parcelRequire("3tS2g");

var $gWwbb = parcelRequire("gWwbb");

var $iXXhl = parcelRequire("iXXhl");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $efwy1 = parcelRequire("efwy1");

var $2XXXw = parcelRequire("2XXXw");
$gWwbb.polyfill();
var $247f49975e2c6903$var$context = /*#__PURE__*/ $g85JO.createContext({
    element: undefined
});
var $247f49975e2c6903$var$provider = $247f49975e2c6903$var$context.Provider;
function $247f49975e2c6903$var$Scrollable$Provider(Props) {
    var children = Props.children;
    var element = Props.element;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$provider, {
        value: {
            element: element
        },
        children: children
    });
}
$247f49975e2c6903$var$Scrollable$Provider.displayName = "Scrollable.Provider";
var $247f49975e2c6903$export$2881499e37b75b9a = {
    context: $247f49975e2c6903$var$context,
    provider: $247f49975e2c6903$var$provider,
    make: $247f49975e2c6903$var$Scrollable$Provider
};
function $247f49975e2c6903$export$c8bd6c217b070147(param) {
    return $g85JO.useContext($247f49975e2c6903$var$context);
}
function $247f49975e2c6903$var$Scrollable(Props) {
    var restorationId = Props.restorationId;
    var scrollToRef = Props.scrollToRef;
    var onScrollOpt = Props.onScroll;
    var childrenOpt = Props.children;
    var lockedOpt = Props.locked;
    var fwdRef = Props.fwdRef;
    var classNameOpt = Props.className;
    var onTouchStart = Props.onTouchStart;
    var onTouchMove = Props.onTouchMove;
    var onTouchEnd = Props.onTouchEnd;
    var scrollOffsetOpt = Props.scrollOffset;
    var defaultRestorationPosition = Props.defaultRestorationPosition;
    var inlineOpt = Props.inline;
    var styleOpt = Props.style;
    var stopPropagationOpt = Props.stopPropagation;
    var rememberScrollPositionOpt = Props.rememberScrollPosition;
    var onScroll = onScrollOpt !== undefined ? onScrollOpt : function onScroll(e, wasAutoScroll) {};
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var locked = lockedOpt !== undefined ? lockedOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var scrollOffset = scrollOffsetOpt !== undefined ? scrollOffsetOpt : 0.0;
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    var style = styleOpt !== undefined ? $loT9g.valFromOption(styleOpt) : {};
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    var rememberScrollPosition = rememberScrollPositionOpt !== undefined ? rememberScrollPositionOpt : true;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var scrollRef = $g85JO.useRef(null);
    var isAutoScroll = $g85JO.useRef(false);
    var previousScroll = $g85JO.useRef(0);
    var match$1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollToTimeout = match$1.setTimeout;
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useRestoreFromPositionTimeout = match$2.setTimeout;
    var match$3 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useAutoScrollTimeout = match$3.setTimeout;
    var match$4 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollLockTimeout = match$4.setTimeout;
    var mergedRef = fwdRef !== undefined ? (0, $iXXhl.default)(scrollRef, fwdRef) : scrollRef;
    var restoration = $2XXXw.useScrollRestoration(restorationId);
    $2whNH.forEach(scrollToRef, function(scrollTo) {
        scrollTo.current = function(el0) {
            useScrollToTimeout(function(param) {
                var el = scrollRef.current;
                if (el == null) return;
                var scrollTop;
                scrollTop = typeof el0 === "number" ? $2whNH.getWithDefault(defaultRestorationPosition, 0.0) : el0.TAG === /* Element */ 0 ? el0._0.offsetTop : el0._0;
                var el$1 = scrollRef.current;
                var options = {
                    top: scrollTop + scrollOffset,
                    left: 0.0,
                    behavior: "smooth"
                };
                if (!(el$1 == null)) el$1.scrollTo(options);
                if (restorationId !== undefined && rememberScrollPosition) {
                    previousScroll.current = scrollTop | 0;
                    return $2XXXw.setCurrentScroll(namespace, restorationId, {
                        TAG: /* Pixels */ 0,
                        _0: scrollTop | 0
                    });
                }
            }, 0);
        };
    });
    var onScroll$1 = function onScroll$1(param) {
        window.dispatchEvent(new Event("scroll"));
        $2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(el) {
            var scrollTop = el.scrollTop | 0;
            var isBlocking = $2XXXw.isBlockingOnScrollEvent(undefined);
            var isGreaterThanStart = $2whNH.mapWithDefault($2whNH.keep(defaultRestorationPosition, function(a) {
                return a > 0.0;
            }), true, function(start) {
                return scrollTop > start;
            });
            var isEnabled = !isBlocking && isGreaterThanStart;
            if (restorationId !== undefined && rememberScrollPosition && isEnabled) {
                previousScroll.current = scrollTop;
                return $2XXXw.setCurrentScroll(namespace, restorationId, {
                    TAG: /* Pixels */ 0,
                    _0: scrollTop
                });
            }
        });
    };
    var restoreFromLock = function restoreFromLock(lock) {
        return $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(scrollEl) {
            var lockEl = lock.element;
            if ($3tS2g.isDescendent(scrollEl, lockEl)) {
                useScrollLockTimeout(function(param) {
                    var currentScrollPosition = scrollEl.scrollTop;
                    var currentElementTop = lockEl.getBoundingClientRect().top;
                    var originalElementTop = lock.boundingClientRect.top;
                    var amountToScroll = currentElementTop - originalElementTop;
                    var newScrollPosition = currentScrollPosition + amountToScroll;
                    scrollEl.scrollTop = newScrollPosition;
                    onScroll$1(undefined);
                }, 0);
                return true;
            } else return false;
        }), false);
    };
    var restoreFromPosition = function restoreFromPosition1(retryOpt, el, position) {
        var retry = retryOpt !== undefined ? retryOpt : 0;
        if (typeof position === "number") {
            var targetScroll = Math.max(scrollOffset, $2whNH.getWithDefault(defaultRestorationPosition, 0.0)) | 0;
            var scrollTop = $2XXXw.getClosestBreakingPoint(previousScroll.current, targetScroll);
            el.scrollTop = scrollTop;
            return;
        }
        if (position.TAG !== /* Pixels */ 0) return;
        var scrollTop$1 = Math.max(scrollOffset, position._0);
        var height = $2whNH.getWithDefault($2whNH.map($2whNH.map($i7mYY.get(Array.prototype.slice.call(el.children), 0), function(prim) {
            return prim.getBoundingClientRect();
        }), function(prim) {
            return prim.height;
        }), 100000);
        if (scrollTop$1 === 0 || scrollTop$1 <= height || retry > 4) {
            el.scrollTop = scrollTop$1;
            return;
        } else return useRestoreFromPositionTimeout(function(param) {
            restoreFromPosition(retry + 1 | 0, el, position);
        }, 16);
    };
    var setisAutoScroll = function setisAutoScroll(param) {
        isAutoScroll.current = true;
        useAutoScrollTimeout(function(param) {
            isAutoScroll.current = false;
        }, 100);
    };
    $g85JO.useLayoutEffect(function() {
        var el = scrollRef.current;
        if (!(el == null)) {
            var lock = restoration.lock;
            if (lock !== undefined) {
                if (!restoreFromLock(lock)) restoreFromPosition(undefined, el, restoration.position);
            } else {
                setisAutoScroll(undefined);
                restoreFromPosition(undefined, el, restoration.position);
            }
        }
    }, [
        restoration
    ]);
    var positionClassName = inline ? "" : "absolute top-0 left-0";
    var tmp = {
        ref: $5bEXW.Ref.domRef(mergedRef),
        "aria-label": "scrollable content",
        className: $1TRFX.make([
            className,
            $ezf3v.prefix(positionClassName),
            $ezf3v.prefix("w-full h-full overflow-x-hidden no-overflow-anchoring overscroll-none"),
            locked ? $ezf3v.prefix("overflow-y-hidden touch-none") : $ezf3v.prefix("overflow-y-scroll touch-pan-y")
        ]),
        role: "region",
        style: style,
        onScroll: function onScroll1(e) {
            if (stopPropagation) {
                e.preventDefault();
                e.stopPropagation();
            }
            onScroll$1(undefined);
            $iv6Yc._2(onScroll, e, isAutoScroll.current);
        }
    };
    if (onTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
    if (onTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(onTouchMove);
    if (onTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(onTouchStart);
    var tmp$1 = {
        dataTestId: "scrollable",
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, children)
    };
    if (restorationId !== undefined) tmp$1.dataId = restorationId;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$Scrollable$Provider, {
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1),
        element: $loT9g.nullable_to_opt(scrollRef.current)
    });
}
$247f49975e2c6903$var$Scrollable.displayName = "Scrollable";
var $247f49975e2c6903$export$dd44f18ab656f3bb = $247f49975e2c6903$var$Scrollable;
 /*  Not a pure module */ 
});
parcelRegister("3tS2g", function(module, exports) {

$parcel$export(module.exports, "isDescendent", function () { return $288dfedeedc2f681$export$965a0cda204ba1d7; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $288dfedeedc2f681$export$965a0cda204ba1d7(ancestor, _descendent) {
    while(true){
        var descendent = _descendent;
        var parent = descendent.parentElement;
        if (parent == null) return false;
        if (parent === ancestor) return true;
        _descendent = parent;
        continue;
    }
}
function $288dfedeedc2f681$export$ec70bc1e11cea5ad(options, element) {
    element.scrollIntoView(options);
}
 /* No side effect */ 
});


parcelRegister("4Q2zg", function(module, exports) {

$parcel$export(module.exports, "useEdgeSwipeDetector", function () { return $385e02a886c671c9$export$11f9a379a9296a15; });
$parcel$export(module.exports, "useEdgeSwipeDetectorImmediate", function () { return $385e02a886c671c9$export$9b8be4be2f76c0b6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $biidj = parcelRequire("biidj");
var $385e02a886c671c9$export$66e76ce6d60c3fb = function getTouchX(e) {
    return e.touches[0].pageX;
};
function $385e02a886c671c9$export$11f9a379a9296a15(param) {
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var lastDetectionTime = $g85JO.useRef(undefined);
    var touchStartX = $g85JO.useRef(undefined);
    var touchEndX = $g85JO.useRef(undefined);
    var didEdgeSwipe = function didEdgeSwipe(param) {
        return $2whNH.getWithDefault($2whNH.map(lastDetectionTime.current, function(t) {
            return Date.now() - t < 200.0;
        }), false);
    };
    $g85JO.useEffect(function() {
        var onTouchStart = function onTouchStart(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            touchStartX.current = x;
        };
        var onTouchMove = function onTouchMove(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            touchEndX.current = x;
        };
        var onTouchEnd = function onTouchEnd(e) {
            var match = touchStartX.current;
            var match$1 = touchEndX.current;
            if (match !== undefined && match$1 !== undefined) {
                var leftEdgeSwipe = match < 20 && (match$1 - match | 0) > 20;
                var rightEdgeSwipe = (windowWidth - match | 0) < 20 && (match$1 - match | 0) < -20;
                if (leftEdgeSwipe || rightEdgeSwipe) lastDetectionTime.current = Date.now();
            }
            touchStartX.current = undefined;
        };
        document.addEventListener("touchstart", onTouchStart, true);
        document.addEventListener("touchmove", onTouchMove, true);
        document.addEventListener("touchend", onTouchEnd, true);
        return function(param) {
            document.removeEventListener("touchstart", onTouchStart, true);
            document.removeEventListener("touchmove", onTouchMove, true);
            document.removeEventListener("touchend", onTouchEnd, true);
        };
    }, []);
    return didEdgeSwipe;
}
function $385e02a886c671c9$export$9b8be4be2f76c0b6(param) {
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var match = $g85JO.useState(function() {
        return false;
    });
    var setDidEdgeSwipe = match[1];
    $g85JO.useEffect(function() {
        var onTouchStart = function onTouchStart(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            var isLeftEdge = x <= 20;
            var isRightEdge = (windowWidth - x | 0) <= 20;
            if (isLeftEdge || isRightEdge) return $iv6Yc._1(setDidEdgeSwipe, function(param) {
                return true;
            });
        };
        var onTouchEnd = function onTouchEnd(e) {
            $iv6Yc._1(setDidEdgeSwipe, function(param) {
                return false;
            });
        };
        document.addEventListener("touchstart", onTouchStart, true);
        document.addEventListener("touchend", onTouchEnd, true);
        return function(param) {
            document.removeEventListener("touchstart", onTouchStart, true);
            document.removeEventListener("touchend", onTouchEnd, true);
        };
    }, []);
    return match[0];
}
var $385e02a886c671c9$export$6683742126cd10b5 = 20;
 /* react Not a pure module */ 
});

parcelRegister("3sSBX", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $285e594aca7fdb2f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $dzlIC = parcelRequire("dzlIC");

var $5tfgg = parcelRequire("5tfgg");

var $hBcYV = parcelRequire("hBcYV");

var $eIwLU = parcelRequire("eIwLU");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");
function $285e594aca7fdb2f$var$Launcher(Props) {
    var style = Props.style;
    var isNestedOpt = Props.isNested;
    var highlightedCategoryId = Props.highlightedCategoryId;
    var categories = Props.categories;
    var forceStyle = Props.forceStyle;
    var centeredOpt = Props.centered;
    var paddedOpt = Props.padded;
    var classNameOpt = Props.className;
    var dataTestId = Props.dataTestId;
    var sliderDataTestId = Props.sliderDataTestId;
    var sliderInsetMargin = Props.sliderInsetMargin;
    var slidesPerView = Props.slidesPerView;
    var onItemMouseEnter = Props.onItemMouseEnter;
    var onItemClick = Props.onItemClick;
    var onTrackClick = Props.onTrackClick;
    var onItemRendered = Props.onItemRendered;
    var ariaLabel = Props.ariaLabel;
    var tabIndex = Props.tabIndex;
    var theme = Props.theme;
    var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
    var centered = centeredOpt !== undefined ? centeredOpt : false;
    var padded = paddedOpt !== undefined ? paddedOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var goTo = match.goTo;
    var match$1 = $9pMGg.use(undefined);
    var onClick = match$1.onLauncherItemClick;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, categories);
    var match$2 = $8E2YL.use(undefined).config;
    var settings = match$2.settings;
    $g85JO.useEffect(function() {
        var isAnyQuickViewStories = $i7mYY.some(categories, $1xf0g.isQuickViewStoriesEnabled);
        if (isAnyQuickViewStories && !isNested) $iv6Yc._1($b8WNX.preload, undefined);
    }, [
        categories
    ]);
    var match$3 = settings.mkrBio;
    var border = match$3 !== undefined && !isNested ? /* BorderBottom */ 1 : /* BorderNone */ 0;
    var match$4 = settings.mkrBio;
    var indicatorThickness = match$4 !== undefined ? /* Sm */ 1 : /* Normal */ 0;
    var match$5 = settings.mkrBio;
    var height = match$5 !== undefined ? /* Lg */ 1 : /* Normal */ 0;
    var activeCategoryPath = $i7mYY.map($2whNH.mapWithDefault($2whNH.map(activeCategory, function(category) {
        return category.id;
    }), [], function(id) {
        return $1xf0g.getCategoryPathById(categories, id);
    }), function(category) {
        return category.id;
    });
    var activeCategoryId = $2whNH.map($i7mYY.getBy(categories, function(category) {
        return activeCategoryPath.includes(category.id);
    }), function(category) {
        return category.id;
    });
    var match$6 = settings.indexNode;
    var activeCategoryId$1 = activeCategoryId !== undefined ? activeCategoryId : match$6 !== undefined && match$6.visibleInMenuBar && match.route !== /* NotRendered */ 0 && !isNested ? match$6.id : undefined;
    var activeCategoryId$2 = $2whNH.keep(activeCategoryId$1, function(param) {
        if ($7bjme.notequal(listPageType, /* History */ 1)) return $7bjme.notequal(listPageType, /* Favorites */ 0);
        else return false;
    });
    var layout = forceStyle !== undefined ? forceStyle : isNested ? settings.nestedCategoryLayout : settings.categoryLayout;
    var size = isNested ? settings.nestedCategorySize : settings.categorySize;
    var onClick$1 = $g85JO.useCallback($iv6Yc.__1(onClick), [
        onClick
    ]);
    var onClick$2 = $2whNH.getWithDefault(onItemClick, onClick$1);
    var onMouseEnter = $2whNH.getWithDefault(onItemMouseEnter, function(param) {});
    var partial_arg = false;
    var items = $i7mYY.map(categories, function(param) {
        return $5tfgg.fromCategory(partial_arg, param);
    });
    var match$7 = settings.mkrBio;
    var match$8 = items.length;
    var items$1 = match$7 !== undefined && match$8 === 1 ? [] : items;
    var onChange = function onChange(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category === undefined) return;
        $2whNH.forEach(onTrackClick, function(onTrackClick) {
            $iv6Yc._1(onTrackClick, category);
        });
        var match = $1xf0g.Link.getCardLink(category);
        if (match === undefined) return $iv6Yc._1(onClick$2, category);
        switch(match.TAG | 0){
            case /* URL */ 0:
                return;
            case /* Category */ 1:
                var match$1 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* Category */ 0,
                            _0: match$1.categoryId
                        },
                        viewPLP: false,
                        filters: match$1.filters,
                        sort: undefined
                    }
                });
            case /* Product */ 2:
                var match$2 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: undefined,
                        productCategoryId: match$2.productCategoryId,
                        productId: match$2.productId,
                        variantId: match$2.variantId,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* StoreCategory */ 3:
                var match$3 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* StoreCategory */ 2,
                            _0: {
                                categoryId: match$3.categoryId,
                                sourceNodeId: category.id
                            }
                        },
                        viewPLP: false,
                        filters: undefined,
                        sort: match$3.sortBy
                    }
                });
            case /* CustomAction */ 4:
                var match$4 = match._0;
                $dzlIC.triggerCustomFunctionWithoutProducts(match$4.code, match$4.name, undefined, undefined);
                return;
        }
    };
    var onHover = function onHover(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category !== undefined) return $iv6Yc._1(onMouseEnter, category);
    };
    if ($7bjme.equal(items$1, [])) return null;
    var tmp = {
        items: items$1,
        layout: layout,
        size: size,
        theme: theme,
        centered: centered,
        verticallyCenter: layout === /* Labels */ 0,
        className: className,
        onChange: onChange,
        onHover: onHover,
        border: border,
        indicatorThickness: indicatorThickness,
        height: height
    };
    if (highlightedCategoryId !== undefined) tmp.highlightValue = $loT9g.valFromOption(highlightedCategoryId);
    if (activeCategoryId$2 !== undefined) tmp.activeValue = $loT9g.valFromOption(activeCategoryId$2);
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    if (sliderDataTestId !== undefined) tmp.sliderDataTestId = $loT9g.valFromOption(sliderDataTestId);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    var tmp$1 = padded ? undefined : 0;
    if (tmp$1 !== undefined) tmp.padding = tmp$1;
    if (onItemRendered !== undefined) tmp.onItemRendered = $loT9g.valFromOption(onItemRendered);
    var tmp$2 = padded ? undefined : /* Zero */ 3;
    if (tmp$2 !== undefined) tmp.gap = $loT9g.valFromOption(tmp$2);
    if (slidesPerView !== undefined) tmp.slidesPerView = slidesPerView;
    if (sliderInsetMargin !== undefined) tmp.sliderInsetMargin = $loT9g.valFromOption(sliderInsetMargin);
    if (ariaLabel !== undefined) tmp.ariaLabel = $loT9g.valFromOption(ariaLabel);
    if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
    return /*#__PURE__*/ $g85JO.createElement($eIwLU.make, tmp);
}
$285e594aca7fdb2f$var$Launcher.displayName = "Launcher";
var $285e594aca7fdb2f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($285e594aca7fdb2f$var$Launcher);
var $285e594aca7fdb2f$export$aa541d093b11ace2 = $285e594aca7fdb2f$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});

})();
//# sourceMappingURL=InlineEntrypoint.bs.bb6f16d9.js.map
